<template lang="pug">
#waiter-list
  .box
    .box-header
      .d-flex.justify-content-start.align-items-center
        .d-flex.justify-content-start.flex-column
          .title
            span 入所申込者一覧
        .d-flex.justify-content-end.align-items-start.align-self-stretch.flex-fill
          button.btn.setting-btn.mr-2(type="button" @click="gotoSetting") 設定
          button.btn.download-btn.mr-2(type="button" @click="gotoDownload") ダウンロード
          button.btn.register-btn(type="button" @click="gotoWaiterRegister") 入所申込者の新規登録
      .error-messages
        .error-message {{ errorMessage }}
    .box-body
      b-tabs(v-model="tabIndex")
        //- after judgement waiters
        b-tab.tab
          template(v-slot:title)
            .tab-title
              span 待機者
              b-spinner.spinner.ml-2(v-if="afterJudgementWaiterCount == null")
              span(v-else)
                span(v-if="afterJudgementWaiterCount == 0") （{{ afterJudgementWaiterCount }}名）
                span.error-message.font-weight-bold(v-else) （{{ afterJudgementWaiterCount }}名）
                .refresh-icon(@click.stop="refreshWaiters" title="再読み込みします")
          AfterJudgementWaiterListTab(ref="afterJudgementWaiterListTab"
            :isLoading="isWaiterLoading" :items="afterJudgementWaiterItems" :rows.sync="afterJudgementWaiterCount"
            @onStatusEdit="showUpdateWaiterStatusModal" @onLabelEdit="showUpdateWaiterLabelModal" @onDelete="confirmDeleteWaiterModal"
            @onOtherFacilitiesApplication="showOtherFacilitiesApplication" @onServiceRegisterGuide="showServiceRegisterGuide"
            @onDetails="gotoWaiterDetail" @changeDisplayTarget="getAfterJudgementWaiterOtherFacilitiesAppilicationCount"
            @onShowFamilies="showFamiliesModal")
        //- before judgement waiters
        b-tab.tab
          template(v-slot:title)
            .tab-title
              span 新規申込者
              b-spinner.spinner.ml-2(v-if="beforeJudgementWaiterCount == null")
              span(v-else)
                span(v-if="beforeJudgementWaiterCount == 0") （{{ beforeJudgementWaiterCount }}名）
                span.error-message.font-weight-bold(v-else) （{{ beforeJudgementWaiterCount }}名）
                .refresh-icon(@click.stop="refreshWaiters" title="再読み込みします")
          BeforeJudgementWaiterListTab(ref="beforeJudgementWaiterListTab"
            :isLoading="isWaiterLoading" :items="beforeJudgementWaiterItems" :rows.sync="beforeJudgementWaiterCount"
            @onStatusEdit="showUpdateWaiterStatusModal" @onLabelEdit="showUpdateWaiterLabelModal" @onDelete="confirmDeleteWaiterModal"
            @onOtherFacilitiesApplication="showOtherFacilitiesApplication" @onServiceRegisterGuide="showServiceRegisterGuide"
            @onDetails="gotoWaiterDetail" @changeDisplayTarget="getBeforeJudgementWaiterOtherFacilitiesAppilicationCount"
            @onShowFamilies="showFamiliesModal")
        //- applicant waiters
        b-tab.tab
          template(v-slot:title)
            .tab-title
              span 要申請対応
              b-spinner.spinner.ml-2(v-if="applicantWaiterCount == null")
              span(v-else)
                span(v-if="applicantWaiterCount == 0") （{{ applicantWaiterCount }}名）
                span.error-message.font-weight-bold(v-else) （{{ applicantWaiterCount }}名）
                .refresh-icon(@click.stop="refreshWaiters" title="再読み込みします")
          ApplicantWaiterListTab(ref="applicantWaiterListTab"
            :isLoading="isWaiterLoading" :items="applicantWaiterItems" :rows.sync="applicantWaiterCount"
            @onStatusEdit="showUpdateWaiterStatusModal" @onLabelEdit="showUpdateWaiterLabelModal" @onDelete="confirmDeleteWaiterModal"
            @onOtherFacilitiesApplication="showOtherFacilitiesApplication" @onServiceRegisterGuide="showServiceRegisterGuide"
            @onConfirm="gotoChangeRequest" @onApplyingForCancel="onApplyingForCancel" @onDetails="gotoWaiterDetail"
            @changeDisplayTarget="getApplicantWaiterOtherFacilitiesAppilicationCount")
        //- canceled waiters
        b-tab.tab
          template(v-slot:title)
            .tab-title
              span 取り下げ
              b-spinner.spinner.ml-2(v-if="canceledWaiterCount == null")
              span(v-else)
                span(v-if="canceledWaiterCount == 0") （{{ canceledWaiterCount }}名）
                span.error-message.font-weight-bold(v-else) （{{ canceledWaiterCount }}名）
                .refresh-icon(@click.stop="refreshWaiters" title="再読み込みします")
          CanceledWaiterListTab(ref="canceledWaiterListTab"
            :isLoading="isWaiterLoading" :items="canceledWaiterItems" :rows.sync="canceledWaiterCount"
            @onStatusEdit="showUpdateWaiterStatusModal" @onLabelEdit="showUpdateWaiterLabelModal" @onDelete="confirmDeleteWaiterModal"
            @onOtherFacilitiesApplication="showOtherFacilitiesApplication" @onServiceRegisterGuide="showServiceRegisterGuide"
            @onDetails="gotoWaiterDetail" @changeDisplayTarget="getCanceledWaiterOtherFacilitiesAppilicationCount"
            @onShowFamilies="showFamiliesModal")
        //- viewable facilities waiters
        b-tab.tab(v-if="_isOverWaiterEnterprisePlan")
          template(v-slot:title)
            .tab-title
              span 他施設のみ申込者
              b-spinner.spinner.ml-2(v-if="waiterViewableFacilitiesWaiterCount == null")
              span(v-else)
                span(v-if="waiterViewableFacilitiesWaiterCount == 0") （{{ waiterViewableFacilitiesWaiterCount }}名）
                span.error-message.font-weight-bold(v-else) （{{ waiterViewableFacilitiesWaiterCount }}名）
                .refresh-icon(@click.stop="refreshWaitersByOtherFacilities" title="再読み込みします")
          WaiterViewableFacilitiesWaiterListTab(ref="waiterViewableFacilitiesWaiterListTab"
            :isLoading="isWaiterViewableFacilitiesWaiterLoading" :items="waiterViewableFacilitiesWaiterItems" :rows.sync="waiterViewableFacilitiesWaiterCount"
            @onOtherFacilitiesApplication="showOtherFacilitiesApplication" @onDetails="gotoWaiterDetail"
            @changeDisplayTarget="getWaiterViewableFacilitiesWaiterOtherFacilitiesAppilicationCount")
        //- temporarily waiters
        b-tab.tab
          template(v-slot:title)
            .tab-title
              span 一時保存
              b-spinner.spinner.ml-2(v-if="temporarilyWaiterCount == null")
              span(v-else)
                span(v-if="temporarilyWaiterCount == 0") （{{ temporarilyWaiterCount }}名）
                span.error-message.font-weight-bold(v-else) （{{ temporarilyWaiterCount }}名）
                .refresh-icon(@click.stop="refreshWaiters" title="再読み込みします")
          TemporarilyWaiterListTab(ref="temporarilyWaiterListTab"
            :isLoading="isWaiterLoading" :items="temporarilyWaiterItems" :rows.sync="temporarilyWaiterCount"
            @onDelete="confirmDeleteWaiterModal" @onWaiterEdit="gotoWaiterEdit" @onLabelEdit="showUpdateWaiterLabelModal" @onDetails="gotoWaiterDetail")

  //- status change modals
  ChangeStatusModal(v-model="showUpdateStatusModal" :title="showUpdateStatusModalTitle" :currentStatus="currentWaiterStatus"
      :changedStatus.sync="changedWaiterStatus" :targetFacilities="concurrentUpdateFacilities" :cancelReasonText.sync="cancelReasonText"
      :statusErrorMessage="statusErrorMessage" @ok="confirmUpdateWaiterStatusModal")
  OkCancelModal(v-model="showUpdateStatusConfirmModal" title="ステップを変更しますか？" @ok="updateWaiterStatus(targetWaiter, changedWaiterStatus)")
  OkModal(v-model="showUpdateStatusSuccessModal" title="変更に成功しました。")
  OkCancelModal(v-model="showUpdateResidentConfirmModal" title="利用者へステップを変更しますか？" @ok="updateResidentStatus(targetWaiter, changedWaiterStatus, updateResident)")

  //- label change modals
  ChangeLabelsModal(v-model="showUpdateLabelsModal" :title="showUpdateLabelsModalTitle" :labels.sync="modalInputLabels" @ok="confirmUpdateWaiterLabelsModal")
  OkCancelModal(v-model="showUpdateLabelsConfirmModal" title="ラベルを変更しますか？" @ok="updateWaiterLabels(targetWaiter, modalInputLabels)")
  OkModal(v-model="showUpdateLabelsSuccessModal" title="変更に成功しました。")

  //- applying for cancel modals
  WaiterChangeApplicationMessageModal(v-model="showAcceptanceMessageModal" modalTitle="取り下げ申請の受理メッセージを入力してください"
    :title.sync="messageTitle" :text.sync="messageText" @onSend="showAcceptanceConfirm")
  WaiterChangeApplicationMessageConfirmModal(v-model="showAcceptanceConfirmModal" message="取り下げ申請を受理し、メッセージを送信します。よろしいですか？"
    :title="messageTitle" :text="messageText" @onSend="acceptance(applyingForCancelItem)")
  OkModal(v-model="showAcceptanceSuccessModal" title="取り下げ申請を受理しました")
  //- applying for cancel modals
  WaiterChangeApplicationMessageModal(v-model="showRejectionMessageModal" modalTitle="取り下げ申請の不受理メッセージを入力してください"
    :title.sync="messageTitle" :text.sync="messageText" @onSend="showRejectionConfirm")
  WaiterChangeApplicationMessageConfirmModal(v-model="showRejectionConfirmModal" message="取り下げ申請を不受理にし、メッセージを送信します。よろしいですか？"
    :title="messageTitle" :text="messageText" @onSend="rejection(applyingForCancelItem)")
  OkModal(v-model="showRejectionSuccessModal" title="取り下げ申請を不受理にしました")

  //- waiter delete modals
  WaiterCheckDeleteModal(v-model="showDeleteConfirmModal"
    :title="showDeleteConfirmModalTitle"
    :sendMessage.sync="sendDeleteMessage" :deleteMessageTitle.sync="deleteModalMessageTitle" :deleteMessageText.sync="deleteModalMessageText"
    :showSendDeleteMessage="showSendDeleteMessage" :targetFacilities="concurrentDeleteFacilities"
    @ok="deleteWaiter(targetWaiter)")
  OkModal(v-model="showDeleteSuccessModal" title="削除に成功しました。")

  //- other facility waiters modals
  OtherFacilitiesApplicationModal(v-model="showOtherFacilitiesApplicationModal" :waiterName="waiterName" :items="otherFacilitiesApplicationItems" 
    :fields="otherFacilitiesApplicationFields" :isLoading="otherFacilitiesApplicationLoading")

  //- waiter family register guide modal
  RegistrationGuidePdfModal(ref="pdf")

  //- family detail modal
  FamilyDetailModal(v-model="showFamilyDetailModal" :families="families" :hideFunctions="true" :allDeleteButton="true"
    @onEdit="gotoFamilyEdit" @onLineDelete="showConfirmWaiterFamilyDeleteModal" @onMailDelete="showConfirmMailWaiterFamilyDeleteModal"
    @onSendMessage="showTestMailModal" @onAllDelete="showConfirmAllWaiterFamilyDeleteModal")

  //- family delete modals
  FamilyCheckAndMessageDeleteModal(
    v-model="showDeleteFamilyModal"
    :title="deleteMessage" :targetFacilities="concurrentDeleteFacilities"
    :sendMessage.sync="sendDeleteMessage" :deleteMessageTitle.sync="deleteModalMessageTitle" :deleteMessageText.sync="deleteModalMessageText"
    @ok="deleteFamily()")
    template(#message)
      .message 削除前に以下をご確認ください。
      ul.confirm-list
        li 削除したご家族はHitomeQコネクトの機能を使用できなくなります。
        li 削除後にご家族が再使用する場合は、再度ご家族にユーザー登録していただく必要があります。
  FamilyCheckDeleteModal(
    v-model="showDeleteMailFamilyModal"
    :title="deleteMessage" :targetFacilities="concurrentDeleteFacilities"
    @ok="deleteMailFamily()")
    template(#message)
      .message 削除前に以下をご確認ください。
      ul.confirm-list
        li 削除したご家族はHitomeQコネクトからのメールを受信できなくなります。
        li 削除後に再使用する場合は、再度ユーザー登録していただく必要があります。
  FamilyCheckAndMessageDeleteModal(
    v-model="showDeleteAllFamilyModal"
    :title="deleteMessage" :targetFacilities="concurrentDeleteFacilities"
    :sendMessage.sync="sendDeleteMessage" :deleteMessageTitle.sync="deleteModalMessageTitle" :deleteMessageText.sync="deleteModalMessageText"
    @ok="deleteAllFamily()")
    template(#message)
      .message 削除前に以下をご確認ください。
      ul.confirm-list
        li.error-message 全家族ユーザーを削除しようとしています。
        li 削除したご家族はHitomeQコネクトの機能使用できなくなる、またはメールを受信できなくなります。
        li 削除後に再使用する場合は、再度ユーザー登録していただく必要があります。
  OkModal(v-model="showFamilyDeleteSuccessModal" title="削除に成功しました。")

  //- send test mail to family modals
  TestMailModal(v-model="testMailModalShow" :target.sync="testMailFamilyTargetName" :subject.sync="testMailSubject" :text.sync="testMailText"
    :targetType="1" :showValidationAlert.sync="showValidationAlert" @sendMail="confirmSendMail")
  TestMailConfirmModal(v-model="testMailConfirmModalShow" :target="testMailFamilyTargetName" :subject="testMailSubject" :text="testMailText" @sendMail="sendMail")
  OkModal(v-model="showSendMailSuccessModal" title="メールを送信しました。")

  PageLoading(:isBusy="isBusy" :message="loadingMessage")
</template>

<script lang="ts">
import { Component, Inject, Ref, Watch, Vue } from "vue-property-decorator";
import { userStore } from "@/store/store";
import { needRefreshesStore } from "@/store/store";
import { tabIndexesStore } from "@/store/store";
import { ResidentListState, SendMessagesState, SendWaiterMessagesState } from "@/store/NeedRefreshes";

import { PcUrl } from "@/commons/constants/PcUrl";
import SystemError from "@/commons/models/SystemError";
import { errorHandle } from "@/errorHandler";

import WaitersService, { WaitersPatchModel, WaitersGetModel, UpdateType, AdmissionJudgement, UpdateResidentModel, WaitersDeleteModel } from "@/commons/services/Waiters";
import { ResidentStatus } from "@/commons/services/Residents";
import FacilitiesService, { FacilityGetModel } from "@/commons/services/Facilities";
import { TemplateItem, TemplateItemRadioGroup, TemplateItemSection, TemplateType } from "@/commons/services/AdmissionApplicationTemplates";
import {
  CalcType,
  TemplateItemText as JudgeTemplateItemText,
  TemplateItemRadio as JudgeTemplateItemRadio,
  TemplateItemMultipleCheckbox as JudgeTemplateItemMultipleCheckbox
} from "@/commons/services/AdmissionJudgementTemplates";

import AfterJudgementWaiterListTab from "@/pc/containers/waiters/AfterJudgementWaiterListTab.vue";
import BeforeJudgementWaiterListTab from "@/pc/containers/waiters/BeforeJudgementWaiterListTab.vue";
import ApplicantWaiterListTab from "@/pc/containers/waiters/ApplicantWaiterListTab.vue";
import CanceledWaiterListTab from "@/pc/containers/waiters/CanceledWaiterListTab.vue";
import WaiterViewableFacilitiesWaiterListTab from "@/pc/containers/waiters/WaiterViewableFacilitiesWaiterListTab.vue";
import TemporarilyWaiterListTab from "@/pc/containers/waiters/TemporarilyWaiterListTab.vue";
import WaiterLabelsService, { WaiterLabelsGetModel } from "@/commons/services/WaiterLabels";
import { WaiterServicePlanType } from "@/commons/services/WaiterServicePlans";
import FamiliesService, { FamilyDeleteModel, FamilyGetModel, SenderType } from "@/commons/services/Families";
import MailFamiliesService from "@/commons/services/MailFamilies";
import SendMailMessagesService, { SendMailMessagesPostModel } from "@/commons/services/SendMailMessages";

import OkModal from "@/pc/basics/OkModal.vue";
import OkCancelModal from "@/pc/basics/OkCancelModal.vue";
import WaiterCheckDeleteModal from "@/pc/containers/waiters/WaiterCheckDeleteModal.vue";
import PageLoading from "@/pc/basics/PageLoading.vue";
import ChangeStatusModal, { TargetFacility } from "@/pc/containers/waiters/ChangeStatusModal.vue";
import OtherFacilitiesApplicationModal from "@/pc/containers/waiters/OtherFacilitiesApplicationModal.vue";
import RegistrationGuidePdfModal from "@/pc/containers/waiters/RegistrationGuidePdfModal.vue";
import { OtherFacilitiesApplicationTableField, OtherFacilitiesApplicationTableItem } from "@/pc/containers/waiters/OtherFacilitiesApplicationTable.vue";
import { WaiterTableItem } from "@/pc/containers/waiters/WaiterTable.vue";
import ChangeLabelsModal, { WaiterLabel } from "@/pc/containers/waiters/ChangeLabelsModal.vue";
import FamilyDetailModal from "@/pc/components/modals/FamilyDetailModal.vue";
import FamilyCheckDeleteModal from "@/pc/containers/waiters/FamilyCheckDeleteModal.vue";
import FamilyCheckAndMessageDeleteModal from "@/pc/containers/waiters/FamilyCheckAndMessageDeleteModal.vue";
import TestMailModal from "@/pc/components/modals/TestMailModal.vue";
import TestMailConfirmModal from "@/pc/components/modals/TestMailConfirmModal.vue";
import WaiterChangeApplicationMessageModal from "@/pc/containers/waiters/WaiterChangeApplicationMessageModal.vue";
import WaiterChangeApplicationMessageConfirmModal from "@/pc/containers/waiters/WaiterChangeApplicationMessageConfirmModal.vue";

/**
 * ### 待機者一覧画面コンポーネント
 */
@Component({
  components: {
    AfterJudgementWaiterListTab,
    BeforeJudgementWaiterListTab,
    ApplicantWaiterListTab,
    CanceledWaiterListTab,
    WaiterViewableFacilitiesWaiterListTab,
    TemporarilyWaiterListTab,
    OkCancelModal,
    OkModal,
    WaiterCheckDeleteModal,
    ChangeStatusModal,
    ChangeLabelsModal,
    OtherFacilitiesApplicationModal,
    RegistrationGuidePdfModal,
    FamilyDetailModal,
    FamilyCheckDeleteModal,
    FamilyCheckAndMessageDeleteModal,
    TestMailModal,
    TestMailConfirmModal,
    WaiterChangeApplicationMessageModal,
    WaiterChangeApplicationMessageConfirmModal,
    PageLoading
  },
  name: "WaiterList",
  $_veeValidate: { validator: "new" }
})
export default class WaiterList extends Vue {
  /** 待機者サービス */
  @Inject("WaitersService") waitersService!: WaitersService;
  /** 施設サービス */
  @Inject("FacilitiesService") facilitiesService!: FacilitiesService;
  /** 待機者ラベルサービス */
  @Inject("WaiterLabelsService") waiterLabelsService!: WaiterLabelsService;
  /** 家族サービス */
  @Inject("FamiliesService") familiesService!: FamiliesService;
  /** 家族メールユーザーサービス */
  @Inject("MailFamiliesService") mailFamiliesService!: MailFamiliesService;
  /** メール送信サービス */
  @Inject("SendMailMessagesService") sendMailMessagesService!: SendMailMessagesService;

  /** 待機者 */
  @Ref() afterJudgementWaiterListTab!: AfterJudgementWaiterListTab;
  /** 新規申込者 */
  @Ref() beforeJudgementWaiterListTab!: BeforeJudgementWaiterListTab;
  /** 申込者からの変更申請 */
  @Ref() applicantWaiterListTab!: ApplicantWaiterListTab;
  /** 取り下げ */
  @Ref() canceledWaiterListTab!: CanceledWaiterListTab;
  /** 他施設のみ申込者 */
  @Ref() waiterViewableFacilitiesWaiterListTab!: WaiterViewableFacilitiesWaiterListTab;
  /** 一時保存 */
  @Ref() temporarilyWaiterListTab!: TemporarilyWaiterListTab;

  /** ページ全体ローディング表示可否 */
  isBusy: boolean = false;
  /** ローディングメッセージ */
  loadingMessage: string = "";
  /** 自施設にひもづく待機者ローディング表示可否 */
  isWaiterLoading: boolean = false;
  /** 他施設のみ申込者タブ用ローディング表示可否 */
  isWaiterViewableFacilitiesWaiterLoading: boolean = false;

  /** バリデーションアラート表示可否 */
  showValidationAlert: boolean = false;

  /** エラーメッセージ */
  errorMessage: string = "";
  /** 現在表示しているタブ番号 */
  tabIndex: number = 0;

  /** ラベル */
  labels: Array<WaiterLabelsGetModel> = [];
  /** ラベルMap */
  labelMap: Map<number, WaiterLabelsGetModel> = new Map<number, WaiterLabelsGetModel>();

  /** 待機者 */
  waiters: Array<WaitersGetModel> = [];
  /** 他施設申込み中の待機者 */
  waitersByOtherFacilities: Array<WaitersGetModel> = [];
  /** 取下げ理由 */
  cancelReasonText: string = "";

  /** 自施設、他施設の待機者情報を全て読み込んだか否か */
  loadedAll: boolean = false;
  /** 自施設の待機者を読み込んだか否か */
  loadedWaiters: boolean = false;
  /** 他施設の待機者を読み込んだか否か */
  loadedWaitersByOtherFacilities: boolean = false;

  /** 判定済待機者件数 */
  afterJudgementWaiterCount: number | null = null;
  /** 判定済待機者の行 */
  afterJudgementWaiterItems: Array<WaiterTableItem> = [];
  /** 判定済み待機者の件数ローディングが完了しているか */
  loadedAfterJudgementWaiterListTabCounts = false;

  /** 未判定待機者件数 */
  beforeJudgementWaiterCount: number | null = null;
  /** 未判定待機者の行 */
  beforeJudgementWaiterItems: Array<WaiterTableItem> = [];
  /** 未判定待機者の件数ローディングが完了しているか */
  loadedBeforeJudgementWaiterListTabCounts = false;

  /** 変更申請中待機者件数 */
  applicantWaiterCount: number | null = null;
  /** 変更申請中待機者の行 */
  applicantWaiterItems: Array<WaiterTableItem> = [];
  /** 変更申請中待機者の件数ローディングが完了しているか */
  loadedApplicantWaiterListTabCounts = false;

  /** 取下げ待機者件数 */
  canceledWaiterCount: number | null = null;
  /** 取下げ待機者の行 */
  canceledWaiterItems: Array<WaiterTableItem> = [];
  /** 取下げ待機者の件数ローディングが完了しているか */
  loadedCanceledWaiterListTabCounts = false;

  /** 一時保存待機者件数 */
  temporarilyWaiterCount: number | null = null;
  /** 一時保存待機者の行 */
  temporarilyWaiterItems: Array<WaiterTableItem> = [];

  /** 他施設申込待機者件数 */
  waiterViewableFacilitiesWaiterCount: number | null = null;
  /** 他施設申込待機者の行 */
  waiterViewableFacilitiesWaiterItems: Array<WaiterTableItem> = [];
  /** 他施設申込待機者の件数ローディングが完了しているか */
  loadedWaiterViewableFacilitiesWaiterListTabCounts = false;

  /** 状態更新モーダル表示可否 */
  showUpdateStatusModal: boolean = false;
  /** 状態更新モーダルタイトル */
  showUpdateStatusModalTitle: string = "";
  /** 状態更新モーダルで表示する現在の利用者状態 */
  currentWaiterStatus: ResidentStatus | null = null;
  /** 状態更新モーダルで入力する変更後の利用者状態 */
  changedWaiterStatus: ResidentStatus | null = null;
  /** 状態更新モーダルエラーメッセージ */
  statusErrorMessage: string = "";
  /** 状態更新確認モーダル表示可否 */
  showUpdateStatusConfirmModal: boolean = false;
  /** 状態更新完了モーダル表示可否 */
  showUpdateStatusSuccessModal: boolean = false;
  /** 同時更新する他施設の選択情報 */
  concurrentUpdateFacilities: Array<TargetFacility> = [];
  /** 利用者への状態更新情報 */
  updateResident: UpdateResidentModel | null = null;
  /** 利用者への状態更新確認モーダル表示可否 */
  showUpdateResidentConfirmModal: boolean = false;

  /** ラベル更新モーダル表示可否 */
  showUpdateLabelsModal: boolean = false;
  /** ラベル更新モーダルタイトル */
  showUpdateLabelsModalTitle: string = "";
  /** ラベル更新入力用のラベル */
  modalInputLabels: Array<WaiterLabel> = [];
  /** ラベル更新確認モーダル表示可否 */
  showUpdateLabelsConfirmModal: boolean = false;
  /** ラベル更新完了モーダル表示可否 */
  showUpdateLabelsSuccessModal: boolean = false;

  /** 取り下げ申請、対象の待機者 */
  applyingForCancelItem: WaiterTableItem | null = null;
  /** 取り下げ申請、受理メッセージ入力モーダル表示可否 */
  showAcceptanceMessageModal: boolean = false;
  /** 取り下げ申請、受理確認モーダル表示可否 */
  showAcceptanceConfirmModal: boolean = false;
  /** 取り下げ申請、受理完了モーダル表示可否 */
  showAcceptanceSuccessModal: boolean = false;
  /** 取り下げ申請、不受理メッセージ入力モーダル表示可否 */
  showRejectionMessageModal: boolean = false;
  /** 取り下げ申請、不受理確認モーダル表示可否 */
  showRejectionConfirmModal: boolean = false;
  /** 取り下げ申請、不受理完了モーダル表示可否 */
  showRejectionSuccessModal: boolean = false;
  /** 取り下げ申請、受理・不受理メッセージ入力モーダルタイトル */
  messageTitle: string = "";
  /** 取り下げ申請、受理・不受理メッセージ入力モーダル本文 */
  messageText: string = "";

  /** 削除確認モーダル表示可否 */
  showDeleteConfirmModal: boolean = false;
  /** 削除確認モーダルタイトル */
  showDeleteConfirmModalTitle: string = "";
  /** 削除完了モーダル表示可否 */
  showDeleteSuccessModal: boolean = false;
  /** 状態更新、削除対象 */
  targetWaiter: WaitersGetModel | null = null;
  /** 同時削除する他施設の選択情報 */
  concurrentDeleteFacilities: Array<TargetFacility> = [];
  /** 削除メッセージを表示するか否か、家族がいない場合の利用者削除の場合は削除メッセージは送信不要なので表示制御している */
  showSendDeleteMessage: boolean = false;
  /** 削除メッセージの送信可否 */
  sendDeleteMessage: boolean | null = null;
  /** 削除メッセージタイトル */
  deleteModalMessageTitle: string = "";
  /** 削除メッセージ本文 */
  deleteModalMessageText: string = "";

  /** 他施設の申込み状況モーダル表示可否 */
  showOtherFacilitiesApplicationModal: boolean = false;
  /** 他施設の申込み状況モーダルで表示する待機者名 */
  waiterName: string = "";
  /** 他施設の申込み状況テーブル行 */
  otherFacilitiesApplicationItems: Array<OtherFacilitiesApplicationTableItem> = [];
  /** 他施設の申込み状況テーブル列 */
  otherFacilitiesApplicationFields: Array<OtherFacilitiesApplicationTableField> = [];
  /** 他施設の申込み状況テーブルローディング */
  otherFacilitiesApplicationLoading: boolean = false;

  /** 家族ユーザー詳細モーダル表示可否 */
  showFamilyDetailModal: boolean = false;
  /** モーダル表示対象の家族 */
  families: any = {};
  /** モーダル表示対象の待機者 */
  familyDetailTargetWaiter: WaiterTableItem | null = null;

  /** LINE家族削除確認モーダル表示可否 */
  showDeleteFamilyModal: boolean = false;
  /** MAIL家族削除確認モーダル表示可否 */
  showDeleteMailFamilyModal: boolean = false;
  /** 全家族削除確認モーダル表示可否 */
  showDeleteAllFamilyModal: boolean = false;
  /** 削除対象の利用者ID */
  deleteTargetResidentId: number = 0;
  /** 削除対象の家族ID */
  deleteTargetFamilyId: number = 0;
  /** 削除対象の利用者システム一意ID */
  deleteTargetIdInSystem: number = 0;
  /** 削除モーダルに表示するメッセージ */
  deleteMessage: string = "";

  /** 家族削除完了モーダル表示可否 */
  showFamilyDeleteSuccessModal: boolean = false;

  /** テストメールモーダルの表示状態 */
  testMailModalShow: boolean = false;
  /** テストメール宛先 */
  testMailTargetAddress: string = "";
  /** テストメール宛先ソートキー */
  testMailTargetSortKey: string = "";
  /** テストメール宛先家族名(実際には{部屋名}・{利用者名}様 のご家族 {家族名}（{続柄}）様と表示する) */
  testMailFamilyTargetName: string = "";
  /** テストメール宛先家族名 */
  testMailFamilyName: string = "";
  /** テストメール宛先利用者部屋名 */
  testMailResidentRoom: string = "";
  /** テストメール宛先利用者名 */
  testMailResidentName: string = "";
  /** テストメールタイトル */
  testMailSubject: string = "";
  /** テストメール本文 */
  testMailText: string = "";

  /** テストメール確認モーダルの表示状態 */
  testMailConfirmModalShow: boolean = false;

  /** テストメール送信完了モーダル表示可否 */
  showSendMailSuccessModal: boolean = false;

  /** 閲覧可能施設情報のMAP(key:施設ID, value:施設情報) */
  waiterViewableFacilitiesMap: Map<number, FacilityGetModel> = new Map<number, FacilityGetModel>();

  @Watch("sendDeleteMessage")
  changeSendDeleteMessage(sendDeleteMessage: boolean): void {
    this.setCookieForSendDeleteMessage(sendDeleteMessage);
    return;
  }

  /**
   * ### 1ページあたりの表示行数をCookieに設定する
   */
  private setCookieForSendDeleteMessage(sendDeleteMessage: boolean): void {
    // Cookie有効秒数。有効期限は必ず設定しないといけないので、10年分にしておく
    const saveSecond = 10 * 365 * 24 * 60 * 60;
    document.cookie = `waiter-list-send-delete-message=${sendDeleteMessage}; max-age=${saveSecond};`;
    return;
  }

  /** ### プラン(待機者)がエンタープライズ以上かを返す */
  get _isOverWaiterEnterprisePlan(): boolean {
    const planType: WaiterServicePlanType = userStore.facility.waiterServicePlanType;

    if (WaiterServicePlanType.ENTERPRISE <= planType) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * ### vue lifecycle activated
   *
   * - 一度本画面を表示した後に他画面へ遷移し、他画面から戻ってきた場合に呼び出される
   * - エラーをクリアする
   * - storeにリフレッシュが必要と格納されていた場合（以下参照）、画面の初期化を行う
   *   - 他画面で待機者の情報が変更された場合
   *   - 本画面の画面情報取得中に他画面へ遷移した場合
   */
  async activated(): Promise<void> {
    this.$validator.errors.clear();
    this.showValidationAlert = false;

    if (needRefreshesStore.waiterList.waiterList == true) {
      await this.initialize();
      needRefreshesStore.waiterList.waiterList = false;
    }
    return;
  }

  /**
   * ### 自施設の待機者タブの「再読み込み」ボタン押下イベント
   *
   * - 自施設の待機者を最新の状態にする
   */
  async refreshWaiters(): Promise<void> {
    // 自施設の待機者に関する読み込み状態を初期化する
    this.loadedWaiters = false;
    this.loadedAfterJudgementWaiterListTabCounts = false;
    this.loadedBeforeJudgementWaiterListTabCounts = false;
    this.loadedApplicantWaiterListTabCounts = false;
    this.loadedCanceledWaiterListTabCounts = false;

    await this.initialize();
    return;
  }

  /**
   * ### 他施設の待機者タブの「再読み込み」ボタン押下イベント
   *
   * - 他施設への申込者を最新の状態にする
   */
  async refreshWaitersByOtherFacilities(): Promise<void> {
    // 他施設に関する読み込み状態を初期化する
    this.loadedWaitersByOtherFacilities = false;
    this.loadedWaiterViewableFacilitiesWaiterListTabCounts = false;

    await this.initialize();
    return;
  }

  /**
   * ### vue lifecycle mounted
   *
   * - タブ位置を復元し、初期化する
   * - モーダルで表示する他施設の待機者情報列を作成する
   */
  public async mounted(): Promise<void> {
    this.$nextTick(() => {
      this.tabIndex = tabIndexesStore.waiterListTabIndex;
      tabIndexesStore.setWaiterListTabIndex({ index: 0 });
    });

    const fields: Array<OtherFacilitiesApplicationTableField> = this.createOtherFacilitiesApplicationFields();
    this.otherFacilitiesApplicationFields = fields;

    // 削除時のメッセージ送信可否はCookieから取得する。取得出来ない場合はnull（未入力）を使用する
    const sendDeleteMessage: boolean | null = this.loadCookieForSendDeleteMessage();
    this.sendDeleteMessage = sendDeleteMessage != null ? sendDeleteMessage : null;

    await this.initialize();

    return;
  }

  /**
   * ### 他施設申込確認モーダルで表示するテーブルの列を作成する
   */
  private createOtherFacilitiesApplicationFields(): Array<OtherFacilitiesApplicationTableField> {
    const fields: Array<OtherFacilitiesApplicationTableField> = [];
    fields.push({ key: "facilityName", label: "施設名", sortable: false, sortDirection: "desc", class: "facility-name" });
    fields.push({ key: "rooms", label: "申込み部屋", sortable: false, sortDirection: "desc", class: "rooms" });
    fields.push({ key: "step", label: "ステップ", sortable: false, sortDirection: "desc", class: "step" });
    return fields;
  }

  private loadCookieForSendDeleteMessage(): boolean | null {
    if (document.cookie) {
      let cookieMap: any = {};
      let cookies: Array<string> = document.cookie.split("; ");
      cookies.forEach(function (value) {
        //cookie名と値に分ける
        let content = value.split("=");
        cookieMap[content[0]] = content[1];
      });

      const sendDeleteMessage: string = cookieMap["waiter-list-send-delete-message"];
      if (sendDeleteMessage == "true") {
        return true;
      } else if (sendDeleteMessage == "false") {
        return false;
      } else {
        return null;
      }
    }

    return null;
  }

  /**
   * ### 画面表示情報作成
   *
   * - 画面表示の高速化のため、以下情報は並列で取得・作成する
   *   - 待機者テーブル表示で使用する待機者のラベルMAP
   *   - 各モーダルの選択肢で使用する閲覧可能施設のMAP
   *   - 自施設に申し込んでいる待機者
   * - 各タブのテーブルで表示する情報を作成する
   *   - 入居判定点数でソートする
   *   - 各タブのテーブルの情報に分けて格納する
   * - 他施設のみ申込者タブのテーブルで表示する情報を作成する
   *   - 閲覧可能施設に申し込んでいる待機者（自施設に申し込んでいる待機者と重複有り）を取得
   *   - 自施設に申込みしていない待機者だけにフィルタリング
   *   - 申込み日時の降順でソートする
   * - 各行の他施設の申込件数を非同期で取得する
   */
  public async initialize(): Promise<void> {
    this.loadedAll = false; // 全体読み込み完了を初期化

    /**
     * 自施設にひもづく待機者情報を取得する
     */
    this.isWaiterLoading = true;

    // 自施設の待機者を全て読み込んでいない場合は取得する
    if (this.loadedWaiters == false) {
      // 待機者タブ、新規申込者タブ、申込者からの変更申請タブ、取り下げタブの表示情報を取得する
      this.afterJudgementWaiterCount = null;
      this.afterJudgementWaiterItems = [];
      this.beforeJudgementWaiterCount = null;
      this.beforeJudgementWaiterItems = [];
      this.canceledWaiterCount = null;
      this.canceledWaiterItems = [];
      this.applicantWaiterCount = null;
      this.applicantWaiterItems = [];
      this.temporarilyWaiterCount = null;
      this.temporarilyWaiterItems = [];
      await this.initializeWaiters();

      // 画面遷移して本画面以外の画面へ遷移した場合はフラグを更新しないようにする
      if (this.$route.path === PcUrl.WaiterList) {
        this.loadedWaiters = true; // 自施設の待機者の読み込み完了
      }
    }

    // 待機者タブ、新規申込者タブ、申込者からの変更申請タブ、取り下げタブの「他施設の申込み」列の情報を非同期で取得する
    if (this.loadedAfterJudgementWaiterListTabCounts == false) {
      this.getAfterJudgementWaiterOtherFacilitiesAppilicationCount();
    }
    if (this.loadedBeforeJudgementWaiterListTabCounts == false) {
      this.getBeforeJudgementWaiterOtherFacilitiesAppilicationCount();
    }
    if (this.loadedApplicantWaiterListTabCounts == false) {
      this.getApplicantWaiterOtherFacilitiesAppilicationCount();
    }
    if (this.loadedCanceledWaiterListTabCounts == false) {
      this.getCanceledWaiterOtherFacilitiesAppilicationCount();
    }

    this.isWaiterLoading = false;

    /**
     * 他施設の待機者情報を取得する
     */
    this.isWaiterViewableFacilitiesWaiterLoading = true;

    // 他施設の待機者を全て読み込んでいない場合は取得する
    if (this.loadedWaitersByOtherFacilities == false) {
      // 他施設のみ申込者タブの表示情報を取得する
      this.waiterViewableFacilitiesWaiterCount = null;
      this.waiterViewableFacilitiesWaiterItems = [];
      await this.initializeWaitersByOtherFacilities();

      // 画面遷移して本画面以外の画面へ遷移した場合はフラグを更新しないようにする
      if (this.$route.path === PcUrl.WaiterList) {
        this.loadedWaitersByOtherFacilities = true; // 他施設の待機者の読み込み完了
      }
    }

    // 他施設のみ申込者タブの「他施設の申込み」列の情報を非同期で取得する
    if (this.loadedWaiterViewableFacilitiesWaiterListTabCounts == false) {
      this.getWaiterViewableFacilitiesWaiterOtherFacilitiesAppilicationCount();
    }

    this.isWaiterViewableFacilitiesWaiterLoading = false;

    this.loadedAll = true; // 全体読み込み完了

    return;
  }

  /**
   * ### 待機者の初期化
   */
  public async initializeWaiters(): Promise<void> {
    await Promise.all([this.setWaiterlabelMap(), this.setWaiterViewableFacilitiesMap(), this.setWaiters()]).then((results: Array<any>) => {
      for (const result of results) {
        // 正常終了すればundefinedが返ってくる、それ以外の場合は例外が発生しているのでthrowする
        if (result != undefined) {
          throw result;
        }
      }
    });

    // 自施設に申込んでいる待機者をソートして各タブに振り分ける
    const sortedWaiters: Array<WaitersGetModel> = this.sortWaitersInStatusAndPoint(this.waiters);
    this.setTabWaiters(sortedWaiters, this.labelMap);

    return;
  }

  /**
   * ### 他施設の待機者の初期化
   */
  public async initializeWaitersByOtherFacilities(): Promise<void> {
    // 閲覧可能施設に申し込んでいる待機者を取得して表示させる
    await this.setWaitersByOtherFacilities();
    const dedupedWaitersByOtherFacilities: Array<WaitersGetModel> = this.dedupeWaitersByOtherFacilities(this.waitersByOtherFacilities, this.waiters);
    const sortedWaitersByOtherFacilities: Array<WaitersGetModel> = this.sortWaitersInApplicationDate(dedupedWaitersByOtherFacilities);
    const waiterViewableFacilitiesWaiterItems: Array<WaiterTableItem> = this.createWaiterViewableFacilitiesWaiterItems(sortedWaitersByOtherFacilities);
    this.waiterViewableFacilitiesWaiterItems = waiterViewableFacilitiesWaiterItems;
    this.waiterViewableFacilitiesWaiterCount = waiterViewableFacilitiesWaiterItems.length;

    return;
  }

  /**
   * ### 待機者ラベルMAPを格納する
   */
  public async setWaiterlabelMap(): Promise<void | SystemError> {
    try {
      const labels: Array<WaiterLabelsGetModel> = await this.getWaiterLabels();
      this.labels = labels;
      const labelMap: Map<number, WaiterLabelsGetModel> = this.createLabelMap(labels);
      this.labelMap = labelMap;
    } catch (error) {
      // Promise.all()で並列に実行されるので例外を投げなおすのではなく例外を戻り値として返す
      return error as SystemError;
    }
    return;
  }

  /**
   * ### 待機者ラベルを取得する
   */
  public async getWaiterLabels(): Promise<Array<WaiterLabelsGetModel>> {
    const response: Array<WaiterLabelsGetModel> = await this.waiterLabelsService.gets(userStore);
    return response;
  }

  /**
   * ### 待機者ラベルMAPを作成する
   *
   * - key:ラベルID、value:ラベル
   */
  public createLabelMap(labels: Array<WaiterLabelsGetModel>): Map<number, WaiterLabelsGetModel> {
    let map: Map<number, WaiterLabelsGetModel> = new Map<number, WaiterLabelsGetModel>();
    for (const label of labels) {
      map.set(label.id, label);
    }
    return map;
  }

  /**
   * ### 閲覧可能施設MAPを格納する
   */
  public async setWaiterViewableFacilitiesMap(): Promise<void | SystemError> {
    try {
      const waiterViewableFacilities: Array<FacilityGetModel> = await this.getWaiterViewableFacilities();
      const waiterViewableFacilitiesMap: Map<number, FacilityGetModel> = this.createWaiterViewableFacilitiesMap(waiterViewableFacilities);
      this.waiterViewableFacilitiesMap = waiterViewableFacilitiesMap;
    } catch (error) {
      // Promise.all()で並列に実行されるので例外を投げなおすのではなく例外を戻り値として返す
      return error as SystemError;
    }
    return;
  }

  /**
   * ### 閲覧可能施設を取得する
   */
  public async getWaiterViewableFacilities(): Promise<Array<FacilityGetModel>> {
    const facilities: Array<FacilityGetModel> = [];
    for (const facilityId of userStore.facility.waiterViewableFacilities) {
      const response: FacilityGetModel = await this.facilitiesService.get(userStore, { targetFacilityId: facilityId });
      facilities.push(response);
    }
    return facilities;
  }

  /**
   * ### 閲覧可能施設のMAPを作成する
   *
   * - Key:施設ID、Value:施設情報
   */
  public createWaiterViewableFacilitiesMap(facilities: Array<FacilityGetModel>): Map<number, FacilityGetModel> {
    const waiterViewableFacilitiesMap: Map<number, FacilityGetModel> = new Map<number, FacilityGetModel>();
    for (const facility of facilities) {
      waiterViewableFacilitiesMap.set(facility.id, facility);
    }
    return waiterViewableFacilitiesMap;
  }

  /**
   * ### 待機者を格納する
   */
  public async setWaiters(): Promise<void | SystemError> {
    try {
      const waiters: Array<WaitersGetModel> = await this.getWaiters();
      this.waiters = waiters;
    } catch (error) {
      // Promise.all()で並列に実行されるので例外を投げなおすのではなく例外を戻り値として返す
      return error as SystemError;
    }
    return;
  }

  /**
   * ### 待機者を取得する
   *
   * - 取得制限をしないためstartIndex、endIndexを指定しない
   */
  public async getWaiters(): Promise<Array<WaitersGetModel>> {
    let response: Array<WaitersGetModel> = [];

    try {
      response = await this.waitersService.gets(userStore);
    } catch (error) {
      const systemerror: SystemError = error as SystemError;
      // 413エラーの場合、全件取得した結果がペイロード制限に引っかかったことになるので、index指定で段階的に取得する
      if (systemerror.statusCode == 413) {
        const pagePerCount: number = 50;
        const count: number = await this.waitersService.getCount(userStore);
        const loopEnd: number = Math.ceil(count / pagePerCount);

        for (let i = 0; i < loopEnd; i++) {
          const params: { startIndex: number; endIndex: number } = {
            startIndex: i * pagePerCount,
            endIndex: i * pagePerCount + pagePerCount
          };
          response = response.concat(await this.waitersService.gets(userStore, params));
        }
      }
    }
    return response;
  }

  /**
   * ### 他施設に申し込んでいる待機者を取得する
   */
  public async setWaitersByOtherFacilities(): Promise<void | SystemError> {
    try {
      const waitersByOtherFacilities: Array<WaitersGetModel> = await this.getWaitersByOtherFacilities();
      this.waitersByOtherFacilities = waitersByOtherFacilities;
    } catch (error) {
      // Promise.all()で並列に実行されるので例外を投げなおすのではなく例外を戻り値として返す
      return error as SystemError;
    }
    return;
  }

  /**
   * ### 閲覧可能施設の待機者を取得する
   *
   * - 取得制限をしないためstartIndex、endIndexを指定しない
   */
  public async getWaitersByOtherFacilities(): Promise<Array<WaitersGetModel>> {
    let response: Array<WaitersGetModel> = [];

    try {
      response = await this.waitersService.getsByOtherFacilities(userStore);
    } catch (error) {
      const systemerror: SystemError = error as SystemError;
      // 413エラーの場合、全件取得した結果がペイロード制限に引っかかったことになるので、index指定で段階的に取得する
      if (systemerror.statusCode == 413) {
        const pagePerCount: number = 50;
        const count: number = await this.waitersService.getsByOtherFacilitiesCount(userStore);
        const loopEnd: number = Math.ceil(count / pagePerCount);

        for (let i = 0; i < loopEnd; i++) {
          const params: { startIndex: number; endIndex: number } = {
            startIndex: i * pagePerCount,
            endIndex: i * pagePerCount + pagePerCount
          };
          response = response.concat(await this.waitersService.getsByOtherFacilities(userStore, params));
        }
      }
    }
    return response;
  }

  /**
   * ### 待機者のソート
   *
   * - 状態の降順
   * - 状態が同じ場合は点数の降順
   */
  public sortWaitersInStatusAndPoint(waiters: Array<WaitersGetModel>): Array<WaitersGetModel> {
    return waiters.sort((a: WaitersGetModel, b: WaitersGetModel) => {
      const statusA: ResidentStatus = a.status;
      const statusB: ResidentStatus = b.status;

      if (statusB < statusA) {
        return -1;
      }
      if (statusA < statusB) {
        return 1;
      }
      if (statusA == statusB) {
        const pointA: number = this.getPoint(a.waiter.admissionJudgement);
        const pointB: number = this.getPoint(b.waiter.admissionJudgement);

        if (pointB < pointA) {
          return -1;
        }
        if (pointA < pointB) {
          return 1;
        }
      }

      return 0;
    });
  }

  /**
   * ### 入居判定点数を返す
   */
  public getPoint(admissionJudgement: AdmissionJudgement): number {
    if (admissionJudgement == null || admissionJudgement.templateAnswer == null) {
      return 0;
    }

    let totalPoint: number = 0;
    let replacePoint: number | null = null;
    let points: { totalPoint: number; replacePoint: number | null } = { totalPoint, replacePoint };
    this.calculateReplacePoint(admissionJudgement.templateAnswer.properties, points);
    this.calculateTotalPoint(admissionJudgement.templateAnswer.properties, points);

    if (points.replacePoint != null) {
      return points.replacePoint;
    } else {
      return points.totalPoint;
    }
  }

  /**
   * ### 入居判定の点数を計算する(置換え)
   */
  public calculateReplacePoint(properties: Array<TemplateItem>, points: { totalPoint: number; replacePoint: number | null }): void {
    for (const property of properties) {
      if (property.type == TemplateType.SECTION) {
        const item: TemplateItemSection = property as TemplateItemSection;

        this.calculateReplacePoint(item.properties, points);
      } else if (property.type == TemplateType.RADIO_GROUP) {
        const item: TemplateItemRadioGroup = property as TemplateItemRadioGroup;

        for (const childProperties of item.properties) {
          if (item.answer == childProperties.option.value) {
            this.calculateReplacePoint(childProperties.properties, points);
          }
        }
      } else {
        // テキスト入力
        if (property.type == TemplateType.TEXT) {
          const textItem: JudgeTemplateItemText = property as JudgeTemplateItemText;
          if (textItem.answer == null) {
            continue;
          }

          if (textItem.calcType == CalcType.REPLACE) {
            points.replacePoint = Number(textItem.answer);
          }
        }
        // ラジオ入力
        else if (property.type == TemplateType.RADIO) {
          const radioItem: JudgeTemplateItemRadio = property as JudgeTemplateItemRadio;
          if (radioItem.answer == null) {
            continue;
          }

          if (radioItem.calcType == CalcType.REPLACE) {
            for (const option of radioItem.options) {
              if (radioItem.answer == option.value) {
                points.replacePoint = option.point ? Number(option.point) : (option.point as null);
                break;
              }
            }
          }
        }
        // チェックボックス入力
        else if (property.type == TemplateType.MULTIPLE_CHECKBOX) {
          const multipleCheckboxItem: JudgeTemplateItemMultipleCheckbox = property as JudgeTemplateItemMultipleCheckbox;

          if (multipleCheckboxItem.calcType == CalcType.REPLACE) {
            let point: number | null = null;
            for (let i = 0; i < multipleCheckboxItem.answer.length; i++) {
              if (multipleCheckboxItem.answer[i] == true) {
                if (multipleCheckboxItem.points[i] == null) {
                  continue;
                }
                if (point == null || point < Number(multipleCheckboxItem.points[i])) {
                  point = Number(multipleCheckboxItem.points[i]);
                }
              }
            }

            points.replacePoint = point != null ? point : null;
          }
        }
      }
    }
    return;
  }

  /**
   * ### 入居判定の点数を計算する(加算)
   */
  public calculateTotalPoint(properties: Array<TemplateItem>, points: { totalPoint: number; replacePoint: number | null }): void {
    for (const property of properties) {
      if (property.type == TemplateType.SECTION) {
        const item: TemplateItemSection = property as TemplateItemSection;

        this.calculateTotalPoint(item.properties, points);
      } else if (property.type == TemplateType.RADIO_GROUP) {
        const item: TemplateItemRadioGroup = property as TemplateItemRadioGroup;

        for (const childProperties of item.properties) {
          if (item.answer == childProperties.option.value) {
            this.calculateTotalPoint(childProperties.properties, points);
          }
        }
      } else {
        // テキスト入力
        if (property.type == TemplateType.TEXT) {
          const textItem: JudgeTemplateItemText = property as JudgeTemplateItemText;
          if (textItem.answer == null) {
            continue;
          }

          if (textItem.calcType == CalcType.ADD || textItem.calcType == CalcType.CALC_ADD) {
            points.totalPoint += Number(textItem.answer);
          }
        }
        // ラジオ入力
        else if (property.type == TemplateType.RADIO) {
          const radioItem: JudgeTemplateItemRadio = property as JudgeTemplateItemRadio;
          if (radioItem.answer == null) {
            continue;
          }

          if (radioItem.calcType == CalcType.ADD || radioItem.calcType == CalcType.CALC_ADD) {
            for (const option of radioItem.options) {
              if (radioItem.answer == option.value) {
                points.totalPoint += Number(option.point);
              }
            }
          }
        }
        // チェックボックス入力
        else if (property.type == TemplateType.MULTIPLE_CHECKBOX) {
          const multipleCheckboxItem: JudgeTemplateItemMultipleCheckbox = property as JudgeTemplateItemMultipleCheckbox;

          if (multipleCheckboxItem.calcType == CalcType.ADD || multipleCheckboxItem.calcType == CalcType.CALC_ADD) {
            let point: number = 0;

            for (let i = 0; i < multipleCheckboxItem.answer.length; i++) {
              if (multipleCheckboxItem.answer[i] == true) {
                if (multipleCheckboxItem.points[i] == null) {
                  continue;
                }

                // 計算種別：加算の場合は選択肢で最高得点を採用する
                if (multipleCheckboxItem.calcType == CalcType.ADD) {
                  if (point < Number(multipleCheckboxItem.points[i])) {
                    point = Number(multipleCheckboxItem.points[i]);
                  }
                }
                // 計算種別：計算加算の場合は選択されたpointを合算する
                else if (multipleCheckboxItem.calcType == CalcType.CALC_ADD) {
                  point += Number(multipleCheckboxItem.points[i]);
                }
              }
            }

            // 計算種別：計算加算の場合は上限までの点数とする
            if (multipleCheckboxItem.calcType == CalcType.CALC_ADD && multipleCheckboxItem.limitPoint != null && multipleCheckboxItem.limitPoint != undefined) {
              if (multipleCheckboxItem.limitPoint < point) {
                point = multipleCheckboxItem.limitPoint;
              }
            }

            points.totalPoint += point;
          }
        }
      }
    }
    return;
  }

  /**
   * ### 待機者を各タブのテーブル情報として振り分ける
   *
   * - 以下タブの待機者として振り分ける
   *   - 待機者
   *   - 新規申込者
   *   - 変更申請
   *   - 取り下げ
   *   - 一時保存
   * - タブの「〇件」の表示するために、待機者を振り分けながらカウントする
   */
  public setTabWaiters(waiters: Array<WaitersGetModel>, labelMap: Map<number, WaiterLabelsGetModel>): void {
    let afterJudgementWaiterCount: number = 0;
    let afterJudgementWaiterItems: Array<WaiterTableItem> = [];

    let beforeJudgementWaiterCount: number = 0;
    let beforeJudgementWaiterItems: Array<WaiterTableItem> = [];

    let applicantWaiterCount: number = 0;
    let applicantWaiterItems: Array<WaiterTableItem> = [];

    let canceledWaiterCount: number = 0;
    let canceledWaiterItems: Array<WaiterTableItem> = [];

    let temporarilyWaiterCount: number = 0;
    let temporarilyWaiterItems: Array<WaiterTableItem> = [];

    for (const waiter of waiters) {
      let labels: Array<WaiterLabelsGetModel> = [];
      if (waiter.waiter.labels != null) {
        for (const labelId of waiter.waiter.labels) {
          const label: WaiterLabelsGetModel | undefined = labelMap.get(labelId);
          if (label) {
            labels.push(label);
          }
        }
      }

      switch (waiter.status) {
        /** 待機者タブへの追加 */
        case ResidentStatus.COMPLETE_APPLICATION:
        case ResidentStatus.CONFIRM_ADMISSION:
        case ResidentStatus.FINAL_JUDGE:
        case ResidentStatus.COMPLETE_FINAL_JUDGE:
        case ResidentStatus.ADMISSION_PROCEDURE: {
          afterJudgementWaiterCount++;
          afterJudgementWaiterItems.push({
            ...waiter,
            no: afterJudgementWaiterCount,
            otherFacilitiesAppilicationCount: undefined,
            labels: labels
          });
          break;
        }
        /** 新規申込者タブへの追加 */
        case ResidentStatus.REGISTERD:
        case ResidentStatus.APPLICATION:
        case ResidentStatus.RECEIVED_APPLICATION: {
          beforeJudgementWaiterCount++;
          beforeJudgementWaiterItems.push({
            ...waiter,
            no: beforeJudgementWaiterCount,
            otherFacilitiesAppilicationCount: undefined,
            labels: labels
          });
          break;
        }
        /** 取り下げタブへの追加 */
        case ResidentStatus.CANCELED: {
          canceledWaiterCount++;
          canceledWaiterItems.push({
            ...waiter,
            no: canceledWaiterCount,
            otherFacilitiesAppilicationCount: undefined,
            labels: labels
          });
          break;
        }
        /** 一次保存タブへの追加 */
        case ResidentStatus.TEMPORARILY: {
          temporarilyWaiterCount++;
          temporarilyWaiterItems.push({
            ...waiter,
            no: temporarilyWaiterCount,
            otherFacilitiesAppilicationCount: undefined,
            labels: labels
          });
          break;
        }
      }

      /** 要申請対応タブへの追加 */
      if (waiter.waiter.applyingForChange == true || waiter.waiter.applyingForCancel == true) {
        applicantWaiterCount++;

        applicantWaiterItems.push({
          ...waiter,
          no: applicantWaiterCount,
          otherFacilitiesAppilicationCount: undefined,
          familyCount: 0,
          labels: labels
        });
      }
    }

    this.afterJudgementWaiterCount = afterJudgementWaiterCount;
    this.afterJudgementWaiterItems = afterJudgementWaiterItems;

    this.beforeJudgementWaiterCount = beforeJudgementWaiterCount;
    this.beforeJudgementWaiterItems = beforeJudgementWaiterItems;

    this.canceledWaiterCount = canceledWaiterCount;
    this.canceledWaiterItems = this.sortingCanceledWaiterItemsByUpdated(canceledWaiterItems);

    this.applicantWaiterCount = applicantWaiterCount;
    this.applicantWaiterItems = applicantWaiterItems;

    this.temporarilyWaiterCount = temporarilyWaiterCount;
    this.temporarilyWaiterItems = temporarilyWaiterItems;

    return;
  }

  /**
   * ### 更新日時の降順でソートする
   */
  public sortingCanceledWaiterItemsByUpdated(items: Array<WaiterTableItem>): Array<WaiterTableItem> {
    return items.concat().sort((a: WaiterTableItem, b: WaiterTableItem) => {
      if (b.updated < a.updated) {
        return -1;
      }
      if (a.updated < b.updated) {
        return 1;
      }
      return 0;
    });
  }

  /**
   * ### 待機者タブの「他施設の申込み」列の情報を取得する
   *
   * - 取得範囲はタブ内のテーブルの表示対象ページのみとする
   */
  public async getAfterJudgementWaiterOtherFacilitiesAppilicationCount(): Promise<void> {
    if (this.afterJudgementWaiterListTab) {
      this.loadedAfterJudgementWaiterListTabCounts = false;

      const afterJudgementWaiterListTabCurrentPage: number = this.afterJudgementWaiterListTab.currentPage;
      const afterJudgementWaiterListTabPerPage: number = this.afterJudgementWaiterListTab.perPage;
      await this.setOtherFacilitiesWaiterCountsByCurrentPage(this.afterJudgementWaiterItems, afterJudgementWaiterListTabCurrentPage, afterJudgementWaiterListTabPerPage);

      // 画面遷移して本画面以外の画面へ遷移した場合はフラグを更新しないようにする
      if (this.$route.path === PcUrl.WaiterList) {
        this.loadedAfterJudgementWaiterListTabCounts = true;
      }
    }
    return;
  }

  /**
   * ### 新規申込者タブの「他施設の申込み」列の情報を取得する
   *
   * - 取得範囲はタブ内のテーブルの表示対象ページのみとする
   */
  public async getBeforeJudgementWaiterOtherFacilitiesAppilicationCount(): Promise<void> {
    if (this.beforeJudgementWaiterListTab) {
      this.loadedBeforeJudgementWaiterListTabCounts = false;

      const beforeJudgementWaiterListTabCurrentPage: number = this.beforeJudgementWaiterListTab.currentPage;
      const beforeJudgementWaiterListTabPerPage: number = this.beforeJudgementWaiterListTab.perPage;
      this.setOtherFacilitiesWaiterCountsByCurrentPage(this.beforeJudgementWaiterItems, beforeJudgementWaiterListTabCurrentPage, beforeJudgementWaiterListTabPerPage);

      // 画面遷移して本画面以外の画面へ遷移した場合はフラグを更新しないようにする
      if (this.$route.path === PcUrl.WaiterList) {
        this.loadedBeforeJudgementWaiterListTabCounts = true;
      }
    }
    return;
  }

  /**
   * ### 変更申請タブの「他施設の申込み」列の情報を取得する
   *
   * - 取得範囲はタブ内のテーブルの表示対象ページのみとする
   */
  public async getApplicantWaiterOtherFacilitiesAppilicationCount(): Promise<void> {
    if (this.applicantWaiterListTab) {
      this.loadedApplicantWaiterListTabCounts = false;

      const applicantWaiterListTabCurrentPage: number = this.applicantWaiterListTab.currentPage;
      const applicantWaiterListTabPerPage: number = this.applicantWaiterListTab.perPage;
      this.setOtherFacilitiesWaiterCountsByCurrentPage(this.applicantWaiterItems, applicantWaiterListTabCurrentPage, applicantWaiterListTabPerPage);

      // 画面遷移して本画面以外の画面へ遷移した場合はフラグを更新しないようにする
      if (this.$route.path === PcUrl.WaiterList) {
        this.loadedApplicantWaiterListTabCounts = true;
      }
    }
    return;
  }

  /**
   * ### 取り下げタブの「他施設の申込み」列の情報を取得する
   *
   * - 取得範囲はタブ内のテーブルの表示対象ページのみとする
   */
  public async getCanceledWaiterOtherFacilitiesAppilicationCount(): Promise<void> {
    if (this.canceledWaiterListTab) {
      this.loadedCanceledWaiterListTabCounts = false;

      const canceledWaiterListTabCurrentPage: number = this.canceledWaiterListTab.currentPage;
      const canceledWaiterListTabPerPage: number = this.canceledWaiterListTab.perPage;
      this.setOtherFacilitiesWaiterCountsByCurrentPage(this.canceledWaiterItems, canceledWaiterListTabCurrentPage, canceledWaiterListTabPerPage);

      // 画面遷移して本画面以外の画面へ遷移した場合はフラグを更新しないようにする
      if (this.$route.path === PcUrl.WaiterList) {
        this.loadedCanceledWaiterListTabCounts = true;
      }
    }
    return;
  }

  /**
   * ### 他施設のみ申込者タブの「他施設の申込み」列の情報を取得する
   *
   * - 取得範囲はタブ内のテーブルの表示対象ページのみとする
   */
  public async getWaiterViewableFacilitiesWaiterOtherFacilitiesAppilicationCount(): Promise<void> {
    // プランによってはタブが表示されないのでスキップする
    if (!this._isOverWaiterEnterprisePlan) {
      return;
    }

    if (this.waiterViewableFacilitiesWaiterListTab) {
      this.loadedWaiterViewableFacilitiesWaiterListTabCounts = false;

      const waiterViewableFacilitiesWaiterListTabCurrentPage: number = this.waiterViewableFacilitiesWaiterListTab.currentPage;
      const waiterViewableFacilitiesWaiterListTabPerPage: number = this.waiterViewableFacilitiesWaiterListTab.perPage;
      this.setOtherFacilitiesWaiterCountsByCurrentPage(
        this.waiterViewableFacilitiesWaiterItems,
        waiterViewableFacilitiesWaiterListTabCurrentPage,
        waiterViewableFacilitiesWaiterListTabPerPage
      );

      // 画面遷移して本画面以外の画面へ遷移した場合はフラグを更新しないようにする
      if (this.$route.path === PcUrl.WaiterList) {
        this.loadedWaiterViewableFacilitiesWaiterListTabCounts = true;
      }
    }
    return;
  }

  /**
   * ### 「他施設の申込み」列の情報を取得する
   */
  public async setOtherFacilitiesWaiterCountsByCurrentPage(items: Array<WaiterTableItem>, currentPage: number, perPage: number): Promise<void> {
    const startIndex: number = (currentPage - 1) * perPage; // 現在ページの開始インデックス
    const endIndex: number = Math.min(startIndex + perPage, items.length); // 現在ページの終了インデックス

    let requestPromises: Array<Promise<void>> = [];
    for (let i = startIndex; i < endIndex; i++) {
      if (items[i].otherFacilitiesAppilicationCount == undefined) {
        requestPromises.push(this.setOtherFacilitiesAppilication(items[i]));
      }
    }
    let results: Array<any> = await Promise.all(requestPromises);
    for (const result of results) {
      if (result instanceof SystemError) {
        errorHandle(result, this);
      }
    }

    return;
  }

  /**
   * ### 本施設に登録していないかつ、閲覧可能施設に登録している待機者を取得する
   */
  public async setOtherFacilitiesAppilication(waiter: WaiterTableItem): Promise<void> {
    try {
      const idInSystem: number = waiter.idInSystem;
      const waiters: Array<WaitersGetModel> = await this.waitersService.getsByIdInSystem(userStore, idInSystem);

      if (this.$route.path == PcUrl.WaiterList && waiter != undefined) {
        waiter.otherFacilitiesAppilicationCount = waiters.length;
        waiter.otherFacilitiesAppilicationWaiters = waiters;
      }
    } catch (error) {
      errorHandle(error, this);
    }

    return;
  }

  /**
   * ### 閲覧可能施設の待機者の重複を省いた待機者を返す
   *
   * - 本施設の待機者をMAP化する(key:idInSystem、value:待機者情報)
   * - 閲覧可能施設の待機者で、本施設と同じidInSystemのものを省く
   */
  public dedupeWaitersByOtherFacilities(waitersByOtherFacilities: Array<WaitersGetModel>, waiters: Array<WaitersGetModel>): Array<WaitersGetModel> {
    let dedupedWaiters: Array<WaitersGetModel> = [];

    let waitersMap: Map<number, WaitersGetModel> = new Map();
    for (const waiter of waiters) {
      waitersMap.set(waiter.idInSystem, waiter);
    }

    for (const otherFacilitiesWaiter of waitersByOtherFacilities) {
      const waiter: WaitersGetModel | undefined = waitersMap.get(otherFacilitiesWaiter.idInSystem);
      if (waiter == undefined) {
        dedupedWaiters.push(otherFacilitiesWaiter);
      }
    }

    return dedupedWaiters;
  }

  /**
   * ### 待機者のソート
   *
   * - 申込み日時の降順
   */
  public sortWaitersInApplicationDate(waiters: Array<WaitersGetModel>): Array<WaitersGetModel> {
    return waiters.sort((a: WaitersGetModel, b: WaitersGetModel) => {
      if (b.waiter.admissionApplication.created < a.waiter.admissionApplication.created) {
        return -1;
      }
      if (a.waiter.admissionApplication.created < b.waiter.admissionApplication.created) {
        return 1;
      }

      return 0;
    });
  }

  /**
   * ### 未登録タブのテーブルの行情報を作成する
   */
  public createWaiterViewableFacilitiesWaiterItems(waiters: Array<WaitersGetModel>): Array<WaiterTableItem> {
    let waiterViewableFacilitiesWaiterItems: Array<WaiterTableItem> = [];

    let count: number = 1;
    for (const waiter of waiters) {
      waiterViewableFacilitiesWaiterItems.push({
        ...waiter,
        no: count,
        otherFacilitiesAppilicationCount: undefined,
        labels: [] // 他施設はラベルが無いので、labelは空配列を格納する
      });
      count++;
    }

    return waiterViewableFacilitiesWaiterItems;
  }

  /**
   * ### 待機者の状態変更入力モーダルを表示する
   */
  public async showUpdateWaiterStatusModal(item: WaitersGetModel): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "読込み中...";

    this.showUpdateStatusModalTitle = `${item.name} 様のステップ変更`;
    this.currentWaiterStatus = item.status;
    this.changedWaiterStatus = ResidentStatus.UNKNOWN;
    this.targetWaiter = item;

    const waitersInSystem: Array<WaitersGetModel> = await this.getWaitersInSystem(item.idInSystem);
    const concurrentUpdateFacilities: Array<TargetFacility> = this.createConcurrentFacilities(this.waiterViewableFacilitiesMap, waitersInSystem);
    this.concurrentUpdateFacilities = concurrentUpdateFacilities;

    this.isBusy = false;
    this.showUpdateStatusModal = true;

    return;
  }

  /**
   * ### idInSystemが同じ他施設の待機者を取得する
   */
  public async getWaitersInSystem(residentIdInSystem: number): Promise<Array<WaitersGetModel>> {
    const response: Array<WaitersGetModel> = await this.waitersService.getsByIdInSystem(userStore, residentIdInSystem);
    return response;
  }

  /**
   * ### 同時に更新・削除する施設選択肢を作成する
   */
  public createConcurrentFacilities(viewableFacilityMap: Map<number, FacilityGetModel>, waitersInSystem: Array<WaitersGetModel>): Array<TargetFacility> {
    const targets: Array<TargetFacility> = [];

    for (const waiter of waitersInSystem) {
      if (waiter.status == ResidentStatus.RESIDENT) {
        continue;
      }

      const facility: FacilityGetModel | undefined = viewableFacilityMap.get(waiter.facilityId);
      targets.push({
        id: waiter.facilityId,
        residentId: waiter.id,
        name: facility ? facility.name : "",
        checked: false
      });
    }

    return targets;
  }

  /**
   * ### 待機者の状態変更確認モーダルを表示する
   */
  public confirmUpdateWaiterStatusModal(updateResident: UpdateResidentModel | null): void {
    // updateResidentがnullならただの利用者状態の更新
    if (updateResident == null) {
      this.showUpdateStatusConfirmModal = true;
      return;
    }
    // updateResidentがnull以外なら利用者への状態の更新
    else {
      this.updateResident = updateResident;
      this.showUpdateResidentConfirmModal = true;
    }

    return;
  }

  /**
   * ### 待機者の状態を更新する(利用者以外)
   */
  public async updateWaiterStatus(item: WaitersGetModel, changedWaiterStatus: ResidentStatus): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "更新中...";

    this.showUpdateStatusModal = false;

    try {
      const requestBody: WaitersPatchModel = this.createUpdateWaiterRequestBody(item, changedWaiterStatus, this.concurrentUpdateFacilities);
      await this.waitersService.patch(userStore, item.facilityId, item.id, requestBody);

      // 待機者の状態を更新して再描画するのみで再リクエストはしない
      const newWaiters: Array<WaitersGetModel> = this.waiters.concat();
      for (const waiter of newWaiters) {
        if (waiter.id == item.id) {
          waiter.status = changedWaiterStatus;
          break;
        }
      }
      const sortedNewWaiters: Array<WaitersGetModel> = this.sortWaitersInStatusAndPoint(newWaiters);
      this.setTabWaiters(sortedNewWaiters, this.labelMap);

      // 待機者タブ、新規申込者タブ、申込者からの変更申請タブ、取り下げタブの「他施設の申込み」列の情報を非同期で取得する
      this.getAfterJudgementWaiterOtherFacilitiesAppilicationCount();
      this.getBeforeJudgementWaiterOtherFacilitiesAppilicationCount();
      this.getApplicantWaiterOtherFacilitiesAppilicationCount();
      this.getCanceledWaiterOtherFacilitiesAppilicationCount();

      // サイドメニューを更新
      this.$emit("refresh");

      this.showUpdateStatusSuccessModal = true;
    } catch (error) {
      const systemError: SystemError = error as SystemError;

      if (systemError.statusCode == 409) {
        this.errorMessage = "他の端末で更新されたか、表示している情報が古いために更新できませんでした。情報を再読み込みして、もう一度お試しください。";
      }
      // その他のステータスコードの場合は上位に例外を投げなおす
      else {
        throw error;
      }
    }

    this.isBusy = false;

    return;
  }

  /**
   * ### 待機者更新のリクエストボディを作成する
   */
  public createUpdateWaiterRequestBody(item: WaitersGetModel, changedWaiterStatus: ResidentStatus, concurrentUpdateFacilities: Array<TargetFacility>): WaitersPatchModel {
    let facilities: Array<number> = [];
    for (const facility of concurrentUpdateFacilities) {
      if (facility.checked == true) {
        facilities.push(facility.id);
      }
    }

    // 取下げの場合は取下げ理由を追加する
    if (this.changedWaiterStatus == ResidentStatus.CANCELED) {
      item.waiter.cancelReason = this.cancelReasonText;
    }

    const requestBody: WaitersPatchModel = {
      status: changedWaiterStatus,
      waiter: item.waiter,
      updated: item.updated,
      updateType: UpdateType.STATUS,
      concurrentRegisterFacilities: facilities
    };

    return requestBody;
  }

  /**
   * ### 待機者の状態を更新する(利用者)
   */
  public async updateResidentStatus(item: WaitersGetModel, changedWaiterStatus: ResidentStatus, updateResident: UpdateResidentModel): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "更新中...";

    try {
      const requestBody: WaitersPatchModel = this.createUpdateResidentRequestBody(item, changedWaiterStatus, updateResident, this.concurrentUpdateFacilities);
      await this.waitersService.patch(userStore, item.facilityId, item.id, requestBody);

      // 利用者にステップ変更した場合waitersからitemを削除するだけで再リクエストはしない
      const newWaiters: Array<WaitersGetModel> = this.waiters.concat().filter((waiter: WaitersGetModel) => {
        if (waiter.id == item.id) {
          return false;
        } else {
          return true;
        }
      });
      const sortedNewWaiters: Array<WaitersGetModel> = this.sortWaitersInStatusAndPoint(newWaiters);
      this.setTabWaiters(sortedNewWaiters, this.labelMap);

      // 待機者タブ、新規申込者タブ、申込者からの変更申請タブ、取り下げタブの「他施設の申込み」列の情報を非同期で取得する
      this.getAfterJudgementWaiterOtherFacilitiesAppilicationCount();
      this.getBeforeJudgementWaiterOtherFacilitiesAppilicationCount();
      this.getApplicantWaiterOtherFacilitiesAppilicationCount();
      this.getCanceledWaiterOtherFacilitiesAppilicationCount();

      // 利用者一覧を再読み込みさせるようstoreを更新
      let residentList: ResidentListState = needRefreshesStore.residentList;
      residentList.residentList = true;
      needRefreshesStore.setResidentList(residentList);
      // メッセージ送信の宛先が変更になるので再読み込みさせるようstoreを更新
      let sendMessageState: SendMessagesState = needRefreshesStore.sendMessage;
      sendMessageState.sendMessages = true;
      needRefreshesStore.setSendMessage(sendMessageState);
      // メッセージ送信(待機者)の宛先が変更になるので再読み込みさせるようstoreを更新
      let sendWaiterMessageState: SendWaiterMessagesState = needRefreshesStore.sendWaiterMessage;
      sendWaiterMessageState.sendMessages = true;
      needRefreshesStore.setSendWaiterMessage(sendWaiterMessageState);

      // サイドメニューを更新
      this.$emit("refresh");

      this.showUpdateStatusModal = false;
      this.showUpdateStatusSuccessModal = true;
    } catch (error) {
      const systemError: SystemError = error as SystemError;

      if (systemError.statusCode == 422) {
        this.statusErrorMessage = "ご契約プランの利用者情報登録数上限に達しています。新規に追加する場合は設定画面からプラン変更もしくは利用者情報を削除してから行ってください。";
        return;
      } else if (systemError.statusCode == 409) {
        this.statusErrorMessage = "他の端末で更新されたか、表示している情報が古いために更新できませんでした。情報を再読み込みして、もう一度お試しください。";
      }
      // その他のステータスコードの場合は上位に例外を投げなおす
      else {
        throw error;
      }
    }

    this.isBusy = false;

    return;
  }

  /**
   * ### 利用者更新のリクエストボディを作成する
   */
  public createUpdateResidentRequestBody(
    item: WaitersGetModel,
    changedWaiterStatus: ResidentStatus,
    updateResident: UpdateResidentModel,
    concurrentUpdateFacilities: Array<TargetFacility>
  ): WaitersPatchModel {
    let facilities: Array<number> = [];
    for (const facility of concurrentUpdateFacilities) {
      if (facility.checked == true) {
        facilities.push(facility.id);
      }
    }

    const requestBody: WaitersPatchModel = {
      status: changedWaiterStatus,
      resident: updateResident,
      waiter: item.waiter,
      updated: item.updated,
      updateType: UpdateType.STATUS,
      concurrentRegisterFacilities: facilities
    };

    return requestBody;
  }

  /**
   * ### 待機者のラベル変更入力モーダルを表示する
   */
  public showUpdateWaiterLabelModal(item: WaitersGetModel): void {
    this.targetWaiter = item;
    this.showUpdateLabelsModalTitle = `${item.name} 様のラベル変更`;
    const labelMap: Map<number, number> = this.createWaiterLabelMap(item);
    const labels: Array<WaiterLabel> = this.createLabels(this.labels, labelMap);
    this.modalInputLabels = labels;

    this.showUpdateLabelsModal = true;

    return;
  }

  /**
   * ### 待機者ラベルMAPを作成する
   *
   * - key:ラベルID、value:ラベル
   */
  public createWaiterLabelMap(waiter: WaitersGetModel): Map<number, number> {
    let map: Map<number, number> = new Map<number, number>();
    if (waiter.waiter.labels != null) {
      for (const labelId of waiter.waiter.labels) {
        map.set(labelId, labelId);
      }
    }
    return map;
  }

  /**
   * ### 待機者ラベルの初期値を作成する
   */
  public createLabels(labelMasters: Array<WaiterLabelsGetModel>, waiterLabelMap: Map<number, number>): Array<WaiterLabel> {
    let labels: Array<WaiterLabel> = [];
    for (const master of labelMasters) {
      const checked: boolean = waiterLabelMap.get(master.id) ? true : false;
      labels.push({
        ...master,
        checked: checked
      });
    }
    return labels;
  }

  /**
   * ### 待機者のラベル変更確認モーダルを表示する
   */
  public confirmUpdateWaiterLabelsModal(): void {
    this.showUpdateLabelsConfirmModal = true;
    return;
  }

  /**
   * ### 待機者のラベルを更新する
   */
  public async updateWaiterLabels(item: WaitersGetModel, labels: Array<WaiterLabel>): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "更新中...";

    try {
      const requestBody: WaitersPatchModel = this.createUpdateLabelsRequestBody(item, labels);
      const result: any = await this.waitersService.patch(userStore, item.facilityId, item.id, requestBody);

      // 待機者の状態を更新して再描画するのみで再リクエストはしない
      const newWaiters: Array<WaitersGetModel> = this.waiters.concat();
      for (const waiter of newWaiters) {
        if (waiter.id == item.id) {
          waiter.waiter.labels = requestBody.waiter.labels;
          waiter.updated = result.updated;
          break;
        }
      }
      const sortedNewWaiters: Array<WaitersGetModel> = this.sortWaitersInStatusAndPoint(newWaiters);
      this.setTabWaiters(sortedNewWaiters, this.labelMap);

      // 待機者タブ、新規申込者タブ、申込者からの変更申請タブ、取り下げタブの「他施設の申込み」列の情報を非同期で取得する
      this.getAfterJudgementWaiterOtherFacilitiesAppilicationCount();
      this.getBeforeJudgementWaiterOtherFacilitiesAppilicationCount();
      this.getApplicantWaiterOtherFacilitiesAppilicationCount();
      this.getCanceledWaiterOtherFacilitiesAppilicationCount();

      this.showUpdateLabelsSuccessModal = true;
    } catch (error) {
      const systemError: SystemError = error as SystemError;

      if (systemError.statusCode == 409) {
        this.errorMessage = "他の端末で更新されたか、表示している情報が古いために更新できませんでした。情報を再読み込みして、もう一度お試しください。";
      }
      // その他のステータスコードの場合は上位に例外を投げなおす
      else {
        throw error;
      }
    }

    this.isBusy = false;

    return;
  }

  /**
   * ### 待機者更新のリクエストボディを作成する
   */
  public createUpdateLabelsRequestBody(item: WaitersGetModel, inputLabels: Array<WaiterLabel>): WaitersPatchModel {
    let labels: Array<number> = [];
    for (const label of inputLabels) {
      if (label.checked == true) {
        labels.push(label.id);
      }
    }
    item.waiter.labels = labels;

    const requestBody: WaitersPatchModel = {
      waiter: item.waiter,
      updated: item.updated,
      updateType: UpdateType.LABEL
    };

    return requestBody;
  }

  /**
   * ### 待機者削除確認モーダルを表示する
   */
  public async confirmDeleteWaiterModal(item: WaitersGetModel): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "読込み中...";

    // 家族が登録されている場合は削除メッセージの初期値を入力する
    if (0 < item.familyCount) {
      this.showSendDeleteMessage = true;
      this.deleteModalMessageTitle = "ユーザー登録が削除されました";
      const deleteMessages = [];
      deleteMessages.push(`ご利用の施設から${item.name}様の登録情報が削除されましたので、ユーザー登録を削除させていただきました。`);
      deleteMessages.push("今までHitomeQコネクトをご愛顧いただきありがとうございました。");
      this.deleteModalMessageText = deleteMessages.join("\n");
    } else {
      this.showSendDeleteMessage = false;
      this.deleteModalMessageTitle = "";
      this.deleteModalMessageText = "";
    }

    this.showDeleteConfirmModalTitle = `${item.name ? item.name : "未入力"} 様の入所申込者情報を削除しますか？`;
    this.targetWaiter = item;

    const waitersInSystem: Array<WaitersGetModel> = await this.getWaitersInSystem(item.idInSystem);
    const concurrentDeleteFacilities: Array<TargetFacility> = this.createConcurrentFacilities(this.waiterViewableFacilitiesMap, waitersInSystem);
    this.concurrentDeleteFacilities = concurrentDeleteFacilities;

    // サイドメニューを更新
    this.$emit("refresh");

    this.isBusy = false;
    this.showDeleteConfirmModal = true;

    return;
  }

  /**
   * ### 待機者を削除する
   */
  public async deleteWaiter(item: WaitersGetModel): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "削除中...";
    this.showDeleteConfirmModal = false; // モーダルでバリデーションがあるので呼び出し元で表示／非表示を管理する

    const concurrentDeleteFacilityIds: number[] = [];
    for (const facility of this.concurrentDeleteFacilities) {
      if (facility.checked == true) {
        concurrentDeleteFacilityIds.push(facility.id);
      }
    }
    const requestBody: WaitersDeleteModel = {
      deleteMessageTitle: this.sendDeleteMessage ? this.deleteModalMessageTitle : "",
      deleteMessageText: this.sendDeleteMessage ? this.deleteModalMessageText : "",
      concurrentDeleteFacilityIds
    };
    await this.waitersService.delete(userStore, userStore.loginUser.facilityId, item.id, requestBody);

    // waitersからitemを削除するだけで再リクエストはしない
    this.waiters = this.waiters.concat().filter((waiter: WaitersGetModel) => {
      if (waiter.id == item.id) {
        return false;
      } else {
        return true;
      }
    });
    const sortedNewWaiters: Array<WaitersGetModel> = this.sortWaitersInStatusAndPoint(this.waiters);
    this.setTabWaiters(sortedNewWaiters, this.labelMap);

    // 待機者タブ、新規申込者タブ、申込者からの変更申請タブ、取り下げタブの「他施設の申込み」列の情報を非同期で取得する
    this.getAfterJudgementWaiterOtherFacilitiesAppilicationCount();
    this.getBeforeJudgementWaiterOtherFacilitiesAppilicationCount();
    this.getApplicantWaiterOtherFacilitiesAppilicationCount();
    this.getCanceledWaiterOtherFacilitiesAppilicationCount();

    this.showDeleteSuccessModal = true;
    this.isBusy = false;

    return;
  }

  /**
   * ### 他施設の申込確認モーダルを表示する
   */
  public async showOtherFacilitiesApplication(item: WaiterTableItem): Promise<void> {
    this.waiterName = item.name;
    this.otherFacilitiesApplicationLoading = true;
    this.showOtherFacilitiesApplicationModal = true;

    const waitersInSystem: Array<WaitersGetModel> = item.otherFacilitiesAppilicationWaiters as Array<WaitersGetModel>;
    const tableItems: Array<OtherFacilitiesApplicationTableItem> = this.createOtherFacilitiesApplicationItems(waitersInSystem);
    this.otherFacilitiesApplicationItems = tableItems;

    this.otherFacilitiesApplicationLoading = false;

    return;
  }

  /**
   * ### 他施設の申込確認モーダルで表示する行情報を作成する
   */
  public createOtherFacilitiesApplicationItems(waiters: Array<WaitersGetModel>): Array<OtherFacilitiesApplicationTableItem> {
    let items: Array<OtherFacilitiesApplicationTableItem> = [];

    for (const waiter of waiters) {
      const facility: FacilityGetModel | undefined = this.waiterViewableFacilitiesMap.get(waiter.facilityId);
      items.push({
        ...waiter,
        facilityName: facility != undefined ? facility.name : ""
      });
    }
    return items;
  }

  /**
   * ### 家族の詳細情報を表示する
   */
  public async showFamiliesModal(item: WaiterTableItem): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "読込み中...";

    this.familyDetailTargetWaiter = item;
    this.families = await this.getFamilies(item);
    this.showFamilyDetailModal = true;

    this.isBusy = false;

    return;
  }

  /**
   * ### 待機者にひもづく家族を取得する
   */
  public async getFamilies(item: WaiterTableItem): Promise<Array<FamilyGetModel>> {
    const response: Array<FamilyGetModel> = await this.familiesService.getsInResident(userStore, item.id);
    return response;
  }

  /**
   * ### 家族ユーザー編集画面へ遷移
   */
  public gotoFamilyEdit(family: FamilyGetModel): void {
    this.showFamilyDetailModal = false;
    const waiter: WaiterTableItem = this.familyDetailTargetWaiter as WaiterTableItem;
    this.$router.push({
      name: PcUrl.WaiterFamilyEdit,
      params: { facilityid: `${waiter.facilityId}`, residentid: `${waiter.id}`, idinsystem: `${waiter.idInSystem}`, familyid: `${family.familyId}` }
    });
    return;
  }

  /**
   * ### 家族ユーザー全削除確認モーダルを表示する
   *
   * - 削除メッセージを動的に作成する
   */
  public async showConfirmAllWaiterFamilyDeleteModal(): Promise<void> {
    this.showSendDeleteMessage = true;
    this.deleteModalMessageTitle = "ユーザー登録が削除されました";
    const deleteMessages = [];
    deleteMessages.push(`ご利用の施設から${this.familyDetailTargetWaiter!.name}様の登録情報が削除されましたので、ユーザー登録を削除させていただきました。`);
    deleteMessages.push("今までHitomeQコネクトをご愛顧いただきありがとうございました。");
    this.deleteModalMessageText = deleteMessages.join("\n");

    this.deleteMessage = `${this.familyDetailTargetWaiter!.name}様のご家族全員を削除しますか？`;
    this.deleteTargetResidentId = this.familyDetailTargetWaiter!.id;
    this.deleteTargetFamilyId = this.familyDetailTargetWaiter!.familyId;
    this.deleteTargetIdInSystem = this.familyDetailTargetWaiter!.idInSystem;

    const waitersInSystem: Array<WaitersGetModel> = await this.getWaitersInSystem(this.deleteTargetIdInSystem);
    const concurrentDeleteFacilities: Array<TargetFacility> = this.createConcurrentFacilities(this.waiterViewableFacilitiesMap, waitersInSystem);
    this.concurrentDeleteFacilities = concurrentDeleteFacilities;

    this.showDeleteAllFamilyModal = true;

    return;
  }

  /**
   * ### 全家族ユーザーを削除する
   */
  public async deleteAllFamily(): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "削除中...";
    this.showDeleteAllFamilyModal = false;

    const concurrentDeleteFacilityIds: number[] = [];
    for (const facility of this.concurrentDeleteFacilities) {
      if (facility.checked == true) {
        concurrentDeleteFacilityIds.push(facility.id);
      }
    }
    for (const family of this.families) {
      if (family.senderType == SenderType.LINE) {
        const requestBody: FamilyDeleteModel = {
          deleteMessageTitle: this.sendDeleteMessage ? this.deleteModalMessageTitle : "",
          deleteMessageText: this.sendDeleteMessage ? this.deleteModalMessageText : "",
          concurrentDeleteFacilityIds
        };
        await this.familiesService.delete(userStore, this.deleteTargetResidentId, family.familyId, requestBody);
      } else if (family.senderType == SenderType.MAIL) {
        await this.mailFamiliesService.delete(userStore, this.deleteTargetResidentId, family.familyId, { concurrentDeleteFacilityIds });
      }
    }
    // itemsから削除した利用者を削除するだけで再取得リクエストはしない
    const familyDetailTargetWaiter: WaiterTableItem = this.familyDetailTargetWaiter as WaiterTableItem;
    familyDetailTargetWaiter.familyCount = 0;

    this.showFamilyDetailModal = false;
    this.showFamilyDeleteSuccessModal = true;
    this.isBusy = false;

    return;
  }

  /**
   * ### 家族ユーザー削除確認モーダルを表示する
   *
   * - 削除メッセージを動的に作成する
   */
  public async showConfirmWaiterFamilyDeleteModal(family: FamilyGetModel): Promise<void> {
    this.showSendDeleteMessage = true;
    this.deleteModalMessageTitle = "ユーザー登録が削除されました";
    const deleteMessages = [];
    deleteMessages.push(`ご利用の施設から${this.familyDetailTargetWaiter!.name}様の登録情報が削除されましたので、ユーザー登録を削除させていただきました。`);
    deleteMessages.push("今までHitomeQコネクトをご愛顧いただきありがとうございました。");
    this.deleteModalMessageText = deleteMessages.join("\n");

    const residentName: string = family.name ? family.name : "";
    const familyName: string = family.familyName ? family.familyName : "";
    const familyRelation: string = family.familyRelation ? `（${family.familyRelation}）` : "";
    this.deleteMessage = `${residentName}様のご家族${familyName}${familyRelation}様を削除しますか？`;
    this.deleteTargetResidentId = family.id;
    this.deleteTargetFamilyId = family.familyId;
    this.deleteTargetIdInSystem = this.familyDetailTargetWaiter!.idInSystem;

    const waitersInSystem: Array<WaitersGetModel> = await this.getWaitersInSystem(this.deleteTargetIdInSystem);
    const concurrentDeleteFacilities: Array<TargetFacility> = this.createConcurrentFacilities(this.waiterViewableFacilitiesMap, waitersInSystem);
    this.concurrentDeleteFacilities = concurrentDeleteFacilities;

    this.showDeleteFamilyModal = true;

    return;
  }

  /**
   * ### 家族ユーザーを削除する
   */
  public async deleteFamily(): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "削除中...";
    this.showDeleteFamilyModal = false;

    const concurrentDeleteFacilityIds: number[] = [];
    for (const facility of this.concurrentDeleteFacilities) {
      if (facility.checked == true) {
        concurrentDeleteFacilityIds.push(facility.id);
      }
    }
    const requestBody: FamilyDeleteModel = {
      deleteMessageTitle: this.sendDeleteMessage ? this.deleteModalMessageTitle : "",
      deleteMessageText: this.sendDeleteMessage ? this.deleteModalMessageText : "",
      concurrentDeleteFacilityIds
    };
    await this.familiesService.delete(userStore, this.deleteTargetResidentId, this.deleteTargetFamilyId, requestBody);

    // itemsから削除した利用者を削除するだけで再取得リクエストはしない
    const familyDetailTargetWaiter: WaiterTableItem = this.familyDetailTargetWaiter as WaiterTableItem;
    familyDetailTargetWaiter.familyCount -= 1;

    this.showFamilyDetailModal = false;
    this.showFamilyDeleteSuccessModal = true;
    this.isBusy = false;

    return;
  }

  /**
   * ### 家族メールユーザー削除確認モーダルを表示する
   */
  public async showConfirmMailWaiterFamilyDeleteModal(family: FamilyGetModel): Promise<void> {
    // 削除メッセージを動的に作成する
    const residentName: string = family.name ? family.name : "";
    const familyName: string = family.familyName ? family.familyName : "";
    const familyRelation: string = family.familyRelation ? `（${family.familyRelation}）` : "";
    this.deleteMessage = `${residentName} 様のご家族 ${familyName}${familyRelation}様を削除しますか？`;

    this.deleteTargetResidentId = family.id;
    this.deleteTargetFamilyId = family.familyId;
    this.deleteTargetIdInSystem = this.familyDetailTargetWaiter!.idInSystem;

    const waitersInSystem: Array<WaitersGetModel> = await this.getWaitersInSystem(this.deleteTargetIdInSystem);
    const concurrentDeleteFacilities: Array<TargetFacility> = this.createConcurrentFacilities(this.waiterViewableFacilitiesMap, waitersInSystem);
    this.concurrentDeleteFacilities = concurrentDeleteFacilities;

    this.showDeleteMailFamilyModal = true;

    return;
  }

  /**
   * ### 家族メールユーザーを削除する
   */
  public async deleteMailFamily(): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "削除中...";

    const concurrentDeleteFacilityIds: number[] = [];
    for (const facility of this.concurrentDeleteFacilities) {
      if (facility.checked == true) {
        concurrentDeleteFacilityIds.push(facility.id);
      }
    }
    await this.mailFamiliesService.delete(userStore, this.deleteTargetResidentId, this.deleteTargetFamilyId, { concurrentDeleteFacilityIds });

    // itemsから削除した利用者を削除するだけで再取得リクエストはしない
    const familyDetailTargetWaiter: WaiterTableItem = this.familyDetailTargetWaiter as WaiterTableItem;
    familyDetailTargetWaiter.familyCount -= 1;

    this.showFamilyDetailModal = false;
    this.showFamilyDeleteSuccessModal = true;
    this.isBusy = false;

    return;
  }

  /**
   * ### テストメール送信モーダルを表示する
   *
   * - テストメール送信モーダルに必要な情報を作成する
   * - モーダルを表示する
   */
  public showTestMailModal(family: FamilyGetModel): void {
    this.testMailTargetAddress = family.familyMailaddress ? family.familyMailaddress : "";
    this.testMailTargetSortKey = family.residentsSortKey;
    this.testMailFamilyTargetName = `${family.name}様 のご家族 ${family.familyName}（${family.familyRelation}）様`;
    this.testMailFamilyName = `${family.familyName}`;
    this.testMailResidentName = `${family.name}`;
    this.testMailSubject = "HitomeQコネクト登録確認メール";
    this.testMailText =
      "HitomeQコネクトのメール配信サービスへのお申し込みありがとうございます。\n" +
      "お申し込みのメールアドレスを登録致しました。\n" +
      "後ほど受信確認のご連絡をさせていただきます。\n\n" +
      "もしお心当たりの無い場合は、本メールを削除してください。";

    this.testMailModalShow = true;

    return;
  }

  /**
   * ### テストメール送信確認モーダルを表示する
   *
   * - テストメールの内容をバリデーションする
   * - バリデーションで問題が無ければテストメール確認モーダルを表示する
   */
  public async confirmSendMail(): Promise<void> {
    const validationResult: boolean = await this.$validator.validateAll();
    if (validationResult) {
      this.showValidationAlert = false;
      this.testMailConfirmModalShow = true;
    } else {
      this.showValidationAlert = true;
    }
    return;
  }

  /**
   * ### テストメールを送信する
   *
   * - メールを送信するのでテストメールモーダル、テストメール確認モーダルを非表示にする
   * - メール送信用のパラメータを作成する
   * - メールを送信する
   */
  public async sendMail(): Promise<void> {
    this.testMailModalShow = false;
    this.testMailConfirmModalShow = false;

    this.isBusy = true;
    this.loadingMessage = "送信中...";

    const sendMailMessage: SendMailMessagesPostModel = this.createSendMailMessageModel();
    await this.sendMailMessagesService.post(userStore, sendMailMessage);

    // 送信成功ダイアログを表示する
    this.showSendMailSuccessModal = true;
    this.isBusy = false;

    return;
  }

  /**
   * ### メール送信用パラメータを作成する
   */
  public createSendMailMessageModel(): SendMailMessagesPostModel {
    const sendMailMessage: SendMailMessagesPostModel = {
      sortKeys: [this.testMailTargetSortKey],
      targetName: this.testMailFamilyName,
      subject: this.$stringUtil.convertYen(this.testMailSubject),
      text: this.$stringUtil.convertYen(this.testMailText),
      writerId: userStore.loginUser.userId,
      writtenBy: userStore.loginUser.name,
      // メッセージ送信画面でしか使用しないので以下は空相当の情報を格納する
      type: "",
      addOptionText: false,
      addReadButton: false,
      addReplyButton: false,
      fileUrls: [],
      fileNames: [],
      addReceivedMessageUrl: false,
      needDbRegister: false
    };

    return sendMailMessage;
  }

  /**
   * ### 待機者家族用のID通知書を表示する
   */
  public async showServiceRegisterGuide(waiter: WaitersGetModel): Promise<void> {
    const pdf: RegistrationGuidePdfModal = this.$refs.pdf as RegistrationGuidePdfModal;
    await pdf.show(waiter);
    return;
  }

  /**
   * ### 設定画面へ遷移する
   */
  public gotoSetting(): void {
    tabIndexesStore.setWaiterListTabIndex({ index: this.tabIndex });
    this.$router.push(PcUrl.WaiterSetting);
    return;
  }

  /**
   * ### ダウンロード画面へ遷移する
   */
  public gotoDownload(): void {
    tabIndexesStore.setWaiterListTabIndex({ index: this.tabIndex });
    this.$router.push(PcUrl.WaiterListDownload);
    return;
  }

  /**
   * ### 待機者登録画面へ遷移する
   */
  public gotoWaiterRegister(): void {
    tabIndexesStore.setWaiterListTabIndex({ index: this.tabIndex });
    this.$router.push(PcUrl.WaiterRegister);
    return;
  }

  /**
   * ### 待機者変更申請画面へ遷移する
   */
  public gotoChangeRequest(item: WaitersGetModel): void {
    tabIndexesStore.setWaiterListTabIndex({ index: this.tabIndex });
    this.$router.push({
      name: PcUrl.WaiterChangeRequest,
      params: { facilityid: `${item.facilityId}`, residentid: `${item.id}`, idinsystem: `${item.idInSystem}` }
    });
    return;
  }

  /**
   * ### 待機者の取り下げ申請
   *
   * - answerの値がtrueなら受理、falseなら不受理として扱う
   * - 受理の場合は取り下げ申請受理のメッセージ入力モーダルを表示する
   * - 不受理の場合は取り下げ申請不受理のメッセージ入力モーダルを表示する
   */
  public onApplyingForCancel(item: WaiterTableItem, answer: boolean): void {
    this.applyingForCancelItem = item;
    if (answer == true) {
      this.messageTitle = "取り下げ申請受理";
      this.messageText = `${item.name}様の取り下げ申請が${userStore.facility.name}から受理となりました。`;
      this.showAcceptanceMessageModal = true;
    } else {
      this.messageTitle = "取り下げ申請不受理";
      this.messageText = `${item.name}様の取り下げ申請が${userStore.facility.name}から不受理となりました。`;
      this.showRejectionMessageModal = true;
    }
    return;
  }

  /** ### 取り下げ申請の受理確認モーダルを表示する */
  public showAcceptanceConfirm() {
    this.showAcceptanceConfirmModal = true;
    return;
  }

  /** ###  取り下げ申請の受理 */
  public async acceptance(item: WaiterTableItem): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "更新中...";

    try {
      const requestBody: WaitersPatchModel = {
        waiter: item.waiter,
        applyingForCancel: true,
        title: this.messageTitle,
        text: this.messageText,
        updated: item.updated,
        updateType: UpdateType.APPLYING_FOR_CANCEL
      };
      await this.waitersService.patch(userStore, item.facilityId, item.id, requestBody);

      // 待機者の取り下げ申請中かどうかを更新して再描画するのみで再リクエストはしない
      const newWaiters: Array<WaitersGetModel> = this.waiters.concat();
      for (const waiter of newWaiters) {
        if (waiter.id == item.id) {
          waiter.waiter.applyingForCancel = false;
          delete waiter.waiter.applicantFacilityId;
          delete waiter.waiter.applicantSortKey;
          break;
        }
      }
      const sortedNewWaiters: Array<WaitersGetModel> = this.sortWaitersInStatusAndPoint(newWaiters);
      this.setTabWaiters(sortedNewWaiters, this.labelMap);

      // 待機者タブ、新規申込者タブ、申込者からの変更申請タブ、取り下げタブの「他施設の申込み」列の情報を非同期で取得する
      this.getAfterJudgementWaiterOtherFacilitiesAppilicationCount();
      this.getBeforeJudgementWaiterOtherFacilitiesAppilicationCount();
      this.getApplicantWaiterOtherFacilitiesAppilicationCount();
      this.getCanceledWaiterOtherFacilitiesAppilicationCount();

      this.showAcceptanceSuccessModal = true;
    } catch (error) {
      const systemError: SystemError = error as SystemError;

      if (systemError.statusCode == 409) {
        this.errorMessage = "他の端末で更新されたか、表示している情報が古いために更新できませんでした。情報を再読み込みして、もう一度お試しください。";
      }
      // その他のステータスコードの場合は上位に例外を投げなおす
      else {
        throw error;
      }
    } finally {
      this.showAcceptanceMessageModal = false;
      this.showAcceptanceConfirmModal = false;
      this.isBusy = false;
    }

    return;
  }

  /** ### 取り下げ申請の不受理確認モーダルを表示する */
  public showRejectionConfirm() {
    this.showRejectionConfirmModal = true;
    return;
  }

  /** ### 取り下げ申請の不受理 */
  public async rejection(item: WaiterTableItem): Promise<void> {
    this.isBusy = true;
    this.loadingMessage = "更新中...";

    try {
      const requestBody: WaitersPatchModel = {
        waiter: item.waiter,
        applyingForCancel: false,
        title: this.messageTitle,
        text: this.messageText,
        updated: item.updated,
        updateType: UpdateType.APPLYING_FOR_CANCEL
      };
      await this.waitersService.patch(userStore, item.facilityId, item.id, requestBody);

      // 待機者の取り下げ申請中かどうかを更新して再描画するのみで再リクエストはしない
      const newWaiters: Array<WaitersGetModel> = this.waiters.concat();
      for (const waiter of newWaiters) {
        if (waiter.id == item.id) {
          waiter.waiter.applyingForCancel = false;
          delete waiter.waiter.applicantFacilityId;
          delete waiter.waiter.applicantSortKey;
          break;
        }
      }
      const sortedNewWaiters: Array<WaitersGetModel> = this.sortWaitersInStatusAndPoint(newWaiters);
      this.setTabWaiters(sortedNewWaiters, this.labelMap);

      // 待機者タブ、新規申込者タブ、申込者からの変更申請タブ、取り下げタブの「他施設の申込み」列の情報を非同期で取得する
      this.getAfterJudgementWaiterOtherFacilitiesAppilicationCount();
      this.getBeforeJudgementWaiterOtherFacilitiesAppilicationCount();
      this.getApplicantWaiterOtherFacilitiesAppilicationCount();
      this.getCanceledWaiterOtherFacilitiesAppilicationCount();

      this.showRejectionSuccessModal = true;
    } catch (error) {
      const systemError: SystemError = error as SystemError;

      if (systemError.statusCode == 409) {
        this.errorMessage = "他の端末で更新されたか、表示している情報が古いために更新できませんでした。情報を再読み込みして、もう一度お試しください。";
      }
      // その他のステータスコードの場合は上位に例外を投げなおす
      else {
        throw error;
      }
    } finally {
      this.showRejectionMessageModal = false;
      this.showRejectionConfirmModal = false;
      this.isBusy = false;
    }

    return;
  }

  /**
   * ### 待機者詳細画面へ遷移する
   */
  public gotoWaiterDetail(item: WaitersGetModel): void {
    tabIndexesStore.setWaiterListTabIndex({ index: this.tabIndex });
    this.$router.push({ name: PcUrl.WaiterDetail, params: { facilityid: `${item.facilityId}`, residentid: `${item.id}`, idinsystem: `${item.idInSystem}` } });
    return;
  }

  /**
   * ### 待機者修正画面へ遷移する
   */
  public gotoWaiterEdit(item: WaitersGetModel): void {
    tabIndexesStore.setWaiterListTabIndex({ index: this.tabIndex });
    this.$router.push({ name: PcUrl.WaiterEdit, params: { facilityid: `${item.facilityId}`, residentid: `${item.id}`, idinsystem: `${item.idInSystem}`, backtype: "1" } });
    return;
  }

  /**
   * ### vue lifecycle deactivated
   *
   * - TODO 非同期処理リクエストをキャンセルする(全体的な改修が必要)
   * - validatorインスタンスもキャッシュしてしまっているので、リセットする
   */
  async deactivated() {
    // 最後まで読み込みが終わっていない場合は再度遷移した際に読み込みなおすようにstoreに設定する
    if (this.loadedAll == false) {
      needRefreshesStore.waiterList.waiterList = true;
    }
    await this.$validator.reset();
    this.$validator.errors.clear();
    this.showValidationAlert = false;

    return;
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";
@import "../../../styles/pc/_mixin.scss";

#waiter-list {
  max-width: 1280px;
  margin-left: auto;
  margin-right: auto;

  .box-header {
    .title {
      font-size: 22px;
      font-weight: bold;
    }
  }
  .box-body {
    .spinner {
      width: 16px;
      height: 16px;
      color: $loading;
    }
    .refresh-icon {
      @include svg-icon("../../../assets/refresh.svg", $font-base-color, 20px, 20px);
      opacity: 0.5;
      text-shadow: 0 1px 0 #fff;
      cursor: pointer;
    }
    .refresh-icon:hover {
      opacity: 0.75;
    }
  }
}
</style>
